import { jsx as U } from "react/jsx-runtime";
import y, { useMemo as Te, useRef as ne, useCallback as J, useEffect as X, useContext as wt, useState as bt } from "react";
import { FormattedMessage as Lt } from "react-intl";
import { init as yt } from "@rematch/core";
import { startCase as Re, get as q, camelCase as Ct, invert as Me, repeat as Tt, merge as _e, mapKeys as Mt, snakeCase as it, isArray as Ve, pickBy as He, identity as We, mapValues as Bt, uniq as Ut } from "lodash";
import { useDispatch as kt, useSelector as M, useStore as Gt } from "react-redux";
import { SuspendRMReasons as vt } from "@ps/platform-message-framework/maindbm/SuspendRMReasons";
import { RegulatorAccValEventType as xe } from "@ps/platform-message-framework/regulator/RegulatorAccValEventType";
import { RegulatorPlayerValPopupType as qe } from "@ps/platform-message-framework/regulator/RegulatorPlayerValPopupType";
import Be from "debug";
import "react-router-dom";
import Vt from "jwt-decode";
import W from "url-parse";
import { matchPath as st, withRouter as Ht } from "react-router";
import { over as Wt, Frame as Ke } from "@stomp/stompjs";
import { Observable as ot, timer as xt, firstValueFrom as $e, defer as qt, Subject as Kt } from "rxjs";
import { startWith as $t, shareReplay as Yt, filter as at, switchMap as ct, finalize as Qt, share as jt, retryWhen as zt, scan as Jt, tap as Oe, delayWhen as Xt, first as Ye, timeout as Zt } from "rxjs/operators";
import Ft from "sockjs-client";
import * as Ue from "@sentry/react";
import en from "jssha";
import { ClientDevice as V } from "@ps/platform-message-framework/common/ClientDevice";
import { ClientPlatform as F } from "@ps/platform-message-framework/common/ClientPlatform";
import { OSId as Q } from "@ps/platform-message-framework/common/OSId";
import { getCanonicalLocales as tn } from "@formatjs/intl-getcanonicallocales";
import { WebTokenType as h } from "@ps/platform-message-framework/webtokenserver/WebTokenType";
import nn from "clsx";
import { lock as Qe, unlock as he } from "tua-body-scroll-lock";
import rn from "react-dom";
import { Popper as sn, Reference as on } from "react-popper";
import { useForm as an } from "react-final-form";
const cn = {
  span: (...e) => /* @__PURE__ */ U("span", { children: y.Children.toArray(e) }),
  strong: (...e) => /* @__PURE__ */ U("strong", { children: y.Children.toArray(e) }),
  b: (...e) => /* @__PURE__ */ U("b", { children: y.Children.toArray(e) }),
  a: (e, ...n) => /* @__PURE__ */ U("a", { href: e, children: y.Children.toArray(n) }),
  u: (...e) => /* @__PURE__ */ U("u", { children: y.Children.toArray(e) }),
  ol: (...e) => /* @__PURE__ */ U("ol", { children: y.Children.toArray(e) }),
  li: (...e) => /* @__PURE__ */ U("li", { children: y.Children.toArray(e) }),
  br: (...e) => /* @__PURE__ */ U("br", {})
}, ss = ({ resolve: e, domain: n, values: t, ...r }) => {
  const i = Te(() => ({ ...cn, ...t }), [t]), s = Ri(r);
  return /* @__PURE__ */ U(
    Lt,
    {
      ...r,
      ...s,
      values: wi({
        resolve: e,
        domain: n,
        values: i
      })
    }
  );
};
var le = "NOT_FOUND";
function un(e) {
  var n;
  return {
    get: function(r) {
      return n && e(n.key, r) ? n.value : le;
    },
    put: function(r, i) {
      n = {
        key: r,
        value: i
      };
    },
    getEntries: function() {
      return n ? [n] : [];
    },
    clear: function() {
      n = void 0;
    }
  };
}
function dn(e, n) {
  var t = [];
  function r(c) {
    var d = t.findIndex(function(m) {
      return n(c, m.key);
    });
    if (d > -1) {
      var l = t[d];
      return d > 0 && (t.splice(d, 1), t.unshift(l)), l.value;
    }
    return le;
  }
  function i(c, d) {
    r(c) === le && (t.unshift({
      key: c,
      value: d
    }), t.length > e && t.pop());
  }
  function s() {
    return t;
  }
  function o() {
    t = [];
  }
  return {
    get: r,
    put: i,
    getEntries: s,
    clear: o
  };
}
var ln = function(n, t) {
  return n === t;
};
function pn(e) {
  return function(t, r) {
    if (t === null || r === null || t.length !== r.length)
      return !1;
    for (var i = t.length, s = 0; s < i; s++)
      if (!e(t[s], r[s]))
        return !1;
    return !0;
  };
}
function mn(e, n) {
  var t = typeof n == "object" ? n : {
    equalityCheck: n
  }, r = t.equalityCheck, i = r === void 0 ? ln : r, s = t.maxSize, o = s === void 0 ? 1 : s, c = t.resultEqualityCheck, d = pn(i), l = o === 1 ? un(d) : dn(o, d);
  function m() {
    var p = l.get(arguments);
    if (p === le) {
      if (p = e.apply(null, arguments), c) {
        var E = l.getEntries(), N = E.find(function(D) {
          return c(D.value, p);
        });
        N && (p = N.value);
      }
      l.put(arguments, p);
    }
    return p;
  }
  return m.clearCache = function() {
    return l.clear();
  }, m;
}
function En(e) {
  var n = Array.isArray(e[0]) ? e[0] : e;
  if (!n.every(function(r) {
    return typeof r == "function";
  })) {
    var t = n.map(function(r) {
      return typeof r == "function" ? "function " + (r.name || "unnamed") + "()" : typeof r;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + t + "]");
  }
  return n;
}
function _n(e) {
  for (var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    t[r - 1] = arguments[r];
  var i = function() {
    for (var o = arguments.length, c = new Array(o), d = 0; d < o; d++)
      c[d] = arguments[d];
    var l = 0, m, p = {
      memoizeOptions: void 0
    }, E = c.pop();
    if (typeof E == "object" && (p = E, E = c.pop()), typeof E != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof E + "]");
    var N = p, D = N.memoizeOptions, C = D === void 0 ? t : D, v = Array.isArray(C) ? C : [C], A = En(c), S = e.apply(void 0, [function() {
      return l++, E.apply(null, arguments);
    }].concat(v)), I = e(function() {
      for (var B = [], $ = A.length, Y = 0; Y < $; Y++)
        B.push(A[Y].apply(null, arguments));
      return m = S.apply(null, B), m;
    });
    return Object.assign(I, {
      resultFunc: E,
      memoizedResultFunc: S,
      dependencies: A,
      lastResult: function() {
        return m;
      },
      recomputations: function() {
        return l;
      },
      resetRecomputations: function() {
        return l = 0;
      }
    }), I;
  };
  return i;
}
var ut = /* @__PURE__ */ _n(mn), fn = function(n, t) {
  if (t === void 0 && (t = ut), typeof n != "object")
    throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof n));
  var r = Object.keys(n), i = t(
    // @ts-ignore
    r.map(function(s) {
      return n[s];
    }),
    function() {
      for (var s = arguments.length, o = new Array(s), c = 0; c < s; c++)
        o[c] = arguments[c];
      return o.reduce(function(d, l, m) {
        return d[r[m]] = l, d;
      }, {});
    }
  );
  return i;
}, hn = function() {
  function n(t, r) {
    r === void 0 && (r = fn);
    var i = function(o, c) {
      return i = r(t(n)), i(o, c);
    };
    return function(s, o) {
      return i(s, o);
    };
  }
  return n;
}, Sn = function() {
  var n = !1, t = /* @__PURE__ */ new Set();
  return {
    add: function(i) {
      n ? i.forEach(function(s) {
        return s();
      }) : i.forEach(function(s) {
        return t.add(s);
      });
    },
    finish: function(i) {
      t.delete(i);
    },
    startBuilding: function() {
      n = !0, t.forEach(function(i) {
        return i();
      });
    }
  };
}, In = function(n) {
  if (process.env.NODE_ENV !== "production") {
    if (n.sliceState && typeof n.sliceState != "function")
      throw new Error("select plugin config sliceState must be a function");
    if (n.selectorCreator && typeof n.selectorCreator != "function")
      throw new Error("select plugin config selectorCreator must be a function");
  }
}, An = function(n, t, r) {
  if (process.env.NODE_ENV !== "production" && typeof n?.[t] != "function")
    throw new Error("Selector (" + r.name + "/" + t + ") must be a function");
}, Rn = function(n) {
  n === void 0 && (n = {}), In(n);
  var t = n.sliceState || function(d, l) {
    return d[l.name || ""];
  }, r = n.selectorCreator || ut, i = function(l) {
    return function(m) {
      return typeof m == "function" ? r(function(p) {
        return t(p, l);
      }, m) : t(m, l);
    };
  }, s = function(l) {
    return function(m) {
      var p = this;
      return r(function(E) {
        return E;
      }, function(E) {
        return l.call(p, m, E);
      });
    };
  }, o = Sn(), c = hn();
  return {
    exposed: {
      select: c,
      sliceState: t,
      selectorCreator: r
    },
    onModel: function(l) {
      c[l.name] = {};
      var m = typeof l.selectors == "function" ? l.selectors(i(l), r, s) : l.selectors;
      o.add(Object.keys(m || {}).map(function(p) {
        An(m, p, l);
        var E = function N() {
          return o.finish(N), delete c[l.name][p], c[l.name][p] = m[p].call(c[l.name], c), c[l.name][p];
        };
        return Object.defineProperty(c[l.name], p, {
          configurable: !0,
          get: function() {
            return E();
          }
        }), E;
      }));
    },
    onStoreCreated: function(l) {
      o.startBuilding(), l.select = c;
    }
  };
};
const L = async (e, { request: n }) => {
  try {
    return { ...(await n(e)).body, success: !0 };
  } catch (t) {
    const r = t;
    return {
      statusCode: r?.headers?.statusCode,
      success: !1,
      message: r?.body?.message,
      errors: r.body
    };
  }
}, On = {
  async fetch(e, { dispatch: n, request: t }) {
    const { body: r } = await t({ service: "/api/v1-preview/account" });
    n.account.update(r);
  },
  requestHandHistory(e, n) {
    return L(
      {
        service: "/api/v1-preview/account/history/client-history",
        body: e,
        method: "POST",
        http: !0
      },
      n
    );
  },
  requestCasinoHandHistory(e, n) {
    return L(
      {
        service: "/api/v1-preview/account/history/casino-hand",
        body: { ...e, sendByEmail: !0 }
      },
      n
    );
  },
  requestPlayingHistory(e, n) {
    return L(
      {
        service: "/api/v1-preview/account/history/audit",
        body: e,
        method: "POST",
        http: !0
      },
      n
    );
  },
  requestTournamentHistory({ type: e, tournamentId: n }, t) {
    return L(
      { service: "/api/v1-preview/account/history/tournament", body: { type: e, tournId: n } },
      t
    );
  },
  async updateAccount({ fetchAccount: e = !0, ...n }, t) {
    const r = await L(
      {
        service: "/api/v1-preview/account",
        method: "PATCH",
        body: n
      },
      t
    );
    return e && r.success && await t.dispatch.account.fetch(), r;
  },
  async updatePEPHIOSelection(e, n) {
    return await L(
      { service: "/api/v1-preview/account/occupation-pep-hio", method: "POST", body: e },
      n
    );
  },
  async confirmAccountDetails(e, n) {
    return await L(
      {
        service: "/api/v1-preview/account/details/confirmation-action",
        method: "POST",
        body: e
      },
      n
    );
  },
  async updatePokerTimeLimit(e, n) {
    return await L(
      { service: "responsiblegaming.updategamelimits", body: e },
      n
    );
  },
  async mobileVerificationCode(e, n) {
    return await L(
      { service: "/api/v1-preview/account/mobile-code/validate", method: "POST", body: e },
      n
    );
  },
  async resendVerificationCode(e, n) {
    return await L(
      { service: "/api/v1-preview/account/mobile-code/resend" },
      n
    );
  },
  async validateEmailCode(e, n) {
    const t = await L(
      { service: "/api/v1-preview/account/email-code/validate", method: "POST", body: e },
      n
    );
    return await n.dispatch.account.fetch(), t;
  },
  sendValidationEmail(e, { request: n }) {
    return n({ service: "/api/v1-preview/account/validation-email", method: "POST" });
  },
  updateEmailLocaleSettings(e, n) {
    return L(
      { service: "/api/v1-preview/account/locales", method: "POST", body: e },
      n
    );
  },
  updatePassword(e, n) {
    return L(
      { service: "/api/v1-preview/auth/password", body: e, method: "PUT" },
      n
    );
  },
  updatePasswordReminderFlag(e, n) {
    return L(
      { service: "/api/v1-preview/account/password-reminder", method: "POST", body: e },
      n
    );
  },
  updatePlayChips(e, { request: n }) {
    return n({
      service: "/api/v1-preview/account/play-money-refill",
      method: "POST"
    });
  },
  requestAccountHistoryStatement(e, n) {
    return L(
      { service: "/api/v1-preview/account/history/statement", method: "POST", body: e },
      n
    );
  },
  async getLugasStatus(e, { request: n, dispatch: t }) {
    const { body: r } = await n({
      service: "/api/v1-preview/account/lugas-player-status",
      method: "GET"
    });
    return t.account.update({ lugasPlayerStatus: r }), r;
  },
  async sendLugasLongSessionAcknowledgment(e, { request: n, dispatch: t }) {
    await n({
      service: "/api/v1-preview/account/lugas-long-session-ack",
      method: "POST"
    }), t.account.getLugasStatus();
  },
  checkZipPassword(e, n) {
    return L({ service: "responsiblegaming.checkzippassword", body: e }, n);
  }
};
var z = /* @__PURE__ */ ((e) => (e.ADD_TO_HOME_SCREEN = "A2HS", e.AFFILIATE_INFO = "ptiram", e.AFFILIATE_REF = "pstrk.afref", e.BIAB_CUSTOMER = "BIAB_CUSTOMER", e.BIAB_LANGUAGE = "BIAB_LANGUAGE", e.BIAB_TIMEZONE = "BIAB_TZ", e.BRAND = "BRAND", e.CLIENT_TIME_ZONE = "CLIENT_TIME_ZONE", e.COOKIE_NOTIFICATION = "cookieDisclaimer", e.COUNTRY = "CTRY", e.CURRENCY = "CURR", e.DOWNLOAD_BANNER = "ADB", e.FACEBOOK_BROWSER_ID = "_fbp", e.FACEBOOK_CLICK_ID = "_fbc", e.FIRST_LOGIN = "FIRST_LOGIN", e.INSTALL_ID = "XIID", e.INSTITUTION_ID = "institution_id", e.LANGUAGE = "LANG", e.LICENSE = "LCNS", e.LIMITED_MODE = "LMTMOD", e.MAXYMISER_ID = "pstrk.testid", e.MY_NEWS_SEEN = "CRM_TARGETED_SEEN", e.NPS_INTERACTION = "NPS_INTERACTION", e.ODDS_FORMAT = "ODDS_FORMAT", e.ONE_TRUST_CONSENT = "OptanonConsent", e.PROMO = "promo", e.PROMO_IA = "promo_ia", e.REDIRECT_CONTEXT = "REDIRECT_CONTEXT", e.SIGNAL_ID = "signalid", e.SIGNATURE = "SBSG", e.SITE = "SITE", e.SIZMEK_UID = "sizmek_uid", e.SOFT_REDIRECT_CANCELLED = "soft-redirect-cancelled", e.TOKEN = "SBTK", e.USER = "user", e.WEB_ID = "WBID", e))(z || {}), P = /* @__PURE__ */ ((e) => (e.ArgentinePeso = "ARS", e.AustralianDollar = "AUD", e.BelarusianRuble = "BYR", e.BrazilianReal = "BRL", e.BritishPound = "GBP", e.BulgarianLev = "BGN", e.CanadianDollar = "CAD", e.ChileanPeso = "CLP", e.ChineseYuan = "CNY", e.ColombianPeso = "COP", e.CroatianKuna = "HRK", e.CzechKoruna = "CZK", e.DanishKrone = "DKK", e.EstonianKroon = "EEK", e.Euro = "EUR", e.HungarianForint = "HUF", e.IcelandicKrona = "ISK", e.IndianRupee = "INR", e.JapaneseYen = "JPY", e.KazakhstaniTenge = "KZT", e.LatvianLats = "LVL", e.LithuanianLitas = "LTL", e.MexicanPeso = "MXN", e.MoldovanLeu = "MDL", e.MongolianTugrik = "MNT", e.NewTaiwanDollar = "TWD", e.NewZealandDollar = "NZD", e.NorwegianKrone = "NOK", e.ParaguayanGuarani = "PYG", e.PeruvianSol = "PEN", e.PhilippinePeso = "PHP", e.PlayMoney = "PFF", e.PolishZloty = "PLN", e.RomanianLeu = "RON", e.RussianRuble = "RUB", e.SerbianDinar = "RSD", e.SlovakKoruna = "SKK", e.SouthAfricanRand = "ZAR", e.SwedishKrona = "SEK", e.SwissFranc = "CHF", e.ThaiBaht = "THB", e.USDollar = "USD", e.UkrainianHryvnia = "UAH", e.UruguayanPeso = "UYU", e))(P || {}), g = /* @__PURE__ */ ((e) => (e.ABTestPlayingInsightsProfitLoss = "abtest_playing_insights_profitloss", e.AMLLoginMsg = "aml-login-msg", e.AMLLoginMsgVerified = "aml-login-msg-verified", e.AccountChangeMobile = "account_change_mobile", e.AccountCreatedContinue = "AccountCreatedContinue", e.AccountMenuAddressSearch = "acc-menu-address-search", e.Add2HomeScreen = "a2hs", e.AddressUpdateDisabled = "address-update-disabled", e.AllowSoftRedirectCancel = "allow-soft-redirect-cancel", e.BankID = "se-bankid-signup", e.BlackListCheck = "blacklist-check", e.CasinoFavorites = "CasinoFavorites", e.CasinoFreeSpinsToken = "CasinoFreeSpinsToken", e.CasinoGameFeatureBonusFeatures = "CasinoGameFeatureBonusFeatures", e.CasinoGameFeatureMaxBet = "CasinoGameFeatureMaxBet", e.CasinoGameFeatureMinBet = "CasinoGameFeatureMinBet", e.CasinoGameFeatureMultiplier = "CasinoGameFeatureMultiplier", e.CasinoGameFeaturePaylines = "CasinoGameFeaturePaylines", e.CasinoGameFeatureRTP = "CasinoGameFeatureRTP", e.CasinoGameFeatureWilds = "CasinoGameFeatureWilds", e.CasinoGameInfo = "CasinoGameInfo", e.CasinoGameInfoDescription = "CasinoGameInfoDescription", e.CasinoGameInfoDesktop = "CasinoGameInfoDesktop", e.CasinoGameInfoMobile = "CasinoGameInfoMobile", e.CasinoInstantBonusesToken = "CasinoInstantBonusesToken", e.CasinoLimits = "eCasinoLimits", e.CasinoLiveRacesTCReqd = "CasinoLiveRacesTCReqd", e.CasinoLiveRoulette = "CasinoLiveRouletteResultsFeed", e.CasinoNonAuth = "eCasinoNonAuth", e.CasinoRewardsStoreToken = "CasinoRewardsStoreToken", e.CasinoSlotRacesTCReqd = "CasinoSlotRacesTCReqd", e.CasinoSpinOfDay = "CasinoSpinOfTheDay", e.Chest = "chestPageEnabled", e.CommunityForum = "CommunityForumLinksInHeaderAndFooter", e.CrossOperatorInactiveStatus = "CrossOperatorInactiveStatus", e.CustomPIN = "custom-pin", e.DEAllowed = "DE_Allowed", e.DELossLimit = "DE_losslimit", e.DEPanic = "DE_Panic", e.DERemove1kCap = "DE_Remove1kCap", e.DESpendLimit = "DE_SpendLimit", e.DarkModeEnabled = "dark_mode_enabled", e.DisableBuenosAiresFeatures = "DisableBuenosAiresFeatures", e.DisableNewUkAgeVerificationFlow = "DisableNewUkAgeVerificationFlow", e.DisablePendingWithdrawalCancellation = "swc-disable-pending-withdrawal-cancellation", e.DisableRam = "DisableRam", e.DivertRAMToPoker = "DivertRAMToPoker", e.DocumentsRequestPrompt = "document_request_prompt", e.DynamicCmsBanners = "DynamicCmsBanners", e.ESActivitySummaryReport = "ES_ActivitySummaryReport", e.ESportsBookAuth = "eSportsBookAuth", e.EnableATSExchangeBetsLink = "EnableATSExchangeBetsLink", e.EnableATSLegacyPreferences = "EnableATSLegacyPreferences", e.EnableATSMaintenance = "EnableATSMaintenance", e.EnableBigWinningsGQLSubscription = "EnableBigWinningsGQLSubscription", e.EnableCommsPreferencesOnRG = "enableCommsPreferencesOnRG", e.EnableExchange = "EnableExchange", e.EnableOneTrust = "enableOneTrust", e.EnablePanicButton = "enablePanicButton", e.EnableSentry = "enableSentry", e.EnableTombolaContentCBSE = "enableTombolaContentCBSE", e.EuDeOasisStreetAddress = "EUDE_Oasis_Street_Address", e.FeedbackVerification = "feedback-csat-verification", e.FixedPrizeDrawNotificationEnabled = "FixedPrizeDrawNotificationEnabled", e.FooterDateTime = "footer_date_time", e.ForceDefaultLocale = "ForceDefaultLocale", e.FreeBets = "freebets", e.FreeSpins = "eFreeSpinsBonuses", e.Freemium = "eFreemium", e.FreemiumMobile = "eFreemiumMobile", e.GreyhoundRacingEnabled = "ISP_GreyhoundRacingEnabled", e.HandHistoryRAMMyHandHistoryRequests = "HandHistory_RAM_MyHandHistoryRequests", e.HideRemoveSlfImpLimit = "hide_RemoveSlfImpLimit", e.HideRsaTokenMenu = "hideRsaTokenMenu", e.HideStarsPinMenu = "hideStarsPinMenu", e.HomeGamesNewTab = "HomeGamesNewTab", e.HorseRacingEnabled = "ISP_HorseRacingEnabled", e.IDScanHosted = "IDScan-Hosted", e.IDScanSDK = "IDScan-SDK", e.ISPAmericanOdds = "ISP_AmericanOdds", e.ISPAnimalRacingSpecials = "ISP_Release_AnimalRacingSpecials", e.ISPBetBuilder = "ISP_BetBuilder", e.ISPBetBuilderNewTag = "ISP_BetBuilderNewTag", e.ISPBetSlipCustomKeyboard = "ISP_BetSlipCustomKeyboard", e.ISPBonusCash = "ISP_BonusCash", e.ISPCashOut = "ISP_CashOut", e.ISPDataVisualisation = "ISP_DataVisualisation", e.ISPDisplayEventsWithoutMappedMarkets = "ISP_DisplayEventsWithoutMappedMarkets", e.ISPDynamicAlternates = "ISP_DynamicAlternates", e.ISPEnableCorrectScoreTemplate = "ISP_Enable_CorrectScoreTemplate", e.ISPEnableEventPagePopularBetBuilders = "ISP_Enable_EventPagePopularBetBuilders", e.ISPEnableHomePagePopularBetBuilders = "ISP_Enable_HomePagePopularBetBuilders", e.ISPEnableLandingPagePopularBetBuilders = "ISP_Enable_LandingPagePopularBetBuilders", e.ISPEnablePromotionsQuickLink = "ISP_Enable_PromotionsQuickLink", e.ISPExperimentPopularBetBuilderCount = "ISP_Experiment_PopularBetBuilderCount", e.ISPHistoricalBets = "ISP_HistoricalBets", e.ISPICEPromotions = "ISP_ICE_Promotions", e.ISPMigrationBanner = "ISP_Migration_Banner", e.ISPMyStarsFreeBets = "Visibility_MyStars_FreeBets", e.ISPPromotionPicker = "ISP_PromotionPicker", e.ISPPromotions = "ISP_Promotions", e.ISPQuickSwitcher = "ISP_QuickSwitcher", e.ISPReleaseEventPageWidget = "ISP_Release_EventPageWidget", e.ISPRouting = "ISP_Routing", e.ISPScoreboards = "ISP_Scoreboards", e.ISPSportLandingPage = "ISP_Release_SportLandingPage", e.ISPSportsFreeBets = "ISP_FreeBets", e.ISPStatusCheck = "ISP_StatusCheck", e.ISPUnauthenticatedPromotionsQuickLink = "ISP_UnauthenticatedPromotionsQuickLink", e.Ice2Feature = "ice2", e.IceFeature = "eIceFeatureEnabled", e.IceLeaderboard = "eIceLeaderBoard", e.IdpSecondaryLoginEnabled = "idp-secondary-login-enabled", e.InstantBonusesVisibility = "Visibility_MyStars_InstantBonuses", e.JWTEnabled = "JWTEnabled", e.LiveChatSupport = "eLiveChatSupport", e.LoginSEDialogue = "loginSEDialogue", e.LoginSummaryNotificationModification = "login-summary-notification-modification", e.LowBalancePrompt = "wc2-balance-low-prompt", e.LoyaltyWidgetRefresh = "Loyalty_WidgetRefresh", e.MiniGameTickets = "eMiniGameTickets", e.MultiCurrency = "multi-currency", e.NPS = "SW-SimpleNPS", e.NPSPhase2 = "SW-NPSPhase2", e.NewContactSupportForm = "newCsf", e.NoCasinoGameHistory = "noCasinoGameHistory", e.NoLanguages = "noLanguages", e.NoPokerStarsRewards = "noPokerStarsRewards", e.PKRHomeGamesEmptyStateSideWall = "2023.Q1.Poker.HomeGames.RighSideBar.POKER-5484", e.PKRHomeGamesGameTilesUnsupported = "2022.Q2.Poker.HomeGames.GameTiles.WEB-10835", e.PKRHomeGamesJoinAndCreatePublicClubs = "2023.Q4.Poker.HomeGames.JoinAndCreatePublicClubs.POKER-9619", e.PKRHomeGamesLightMode = "2022.Q4.Poker.HomeGames.LightMode.POKER-2246", e.PKRHomeGamesNewSideBar = "2022.Q3.Poker.HomeGames.Sidebar.POKER-258", e.PKRHomeGamesOnboardingCreateGame = "2022.Q2.Poker.HomeGames.OBCreateGame.POKER-348", e.PKRHomeGamesOnboardingFirstTime = "2022.Q3.Poker.HomeGames.OBFirstTimeUX.POKER-378", e.PKRHomeGamesOnboardingJoinClub = "2022.Q2.Poker.HomeGames.OBJoinClub.POKER-371", e.PKRHomeGamesPublicClubSearch = "2023.Q1.Poker.HomeGames.BasicSearch.POKER-252", e.PKRHomeGamesPublicClubs = "2022.Q4.Poker.HomeGames.PublicClubs.POKER-1917", e.PKRHomeGamesQuickCreateTournament = "2022.Q3.Poker.HomeGames.QuickCreateTournament.POKER-1797", e.PKRHomeGamesTheWall = "2022.Q4.Poker.HomeGames.TheWall.POKER-1645", e.PKRHomeGamesVideoChatToggleRedesign = "2022.Q4.Poker.HomeGames.VideoChatToggleRedesign.POKER-2012", e.PKRMultiTableTournamentsVisibility = "2023.Q4.Poker.WebMTT.Visibility.POKER-8355", e.PKRSpinAndGoFlashAvailable = "2023.Q4.Poker.WebSAG.FlashAvailable.POKER-9938", e.PKRSpinAndGoHoldemAvailable = "2023.Q4.Poker.WebSAG.HoldemAvailable.POKER-9938", e.PKRSpinAndGoMaxHoldemAvailable = "2023.Q4.Poker.WebSAG.MaxHoldemAvailable.POKER-8580", e.PKRSpinAndGoOmahaAvailable = "2023.Q4.Poker.WebSAG.OmahaAvailable.POKER-8580", e.PKRSpinAndGoWatchGamesVisibility = "2023.Q4.Poker.WebSAG.WatchGamesVisibility.POKER-7799", e.PRHub = "PromoExp_PromotionsAndRewards", e.PSMessenger = "PSMessenger", e.PSMessengerConfig = "PSMessengerConfig", e.PSMessengerIgnoreLogin = "PSMessengerIgnoreLogin", e.PSMessengerToggle = "PSMessengerToggle", e.PlayMoney = "playMoney", e.PmcPaywall = "pmc-paywall", e.PredictorGame = "predictorGameEnabled", e.PublicLiveChatSupport = "ePublicLiveChatSupport", e.RGLugasDepositLimit = "RGLugasDepositLimit", e.ReleaseBonuses = "ReleaseBonuses", e.RemoveUserIdFromIframeUrl = "remove-userid-from-iframe", e.ResolverRewriteForWC2 = "resolver-rewrite-for-wc2", e.RestrictSeWeeklyLimit = "restrict-se-weekly-limit", e.RewardsStore = "Visibility_MyStars_RewardsStore", e.RmfEmployerInfo = "rmf-employer-info", e.SFConfig = "SFConfig", e.SelfExclusionNewDesign = "SelfExclusionNewDesign", e.SeparatedEulaPrivacyPolicy = "separated_eula_privacy_policy", e.SessionPopupExtended = "sessionPopupExtended", e.ShowJackpotWheel = "Show-Jackpot-Wheel", e.SignUpShowState = "SignUpShowState", e.SnowplowAnalytics = "snowplow-analytics", e.SportsBonusCash = "Visibility_MyStars_BonusCash", e.SportsBookLimits = "eSportsBookLimits", e.SportsBookNonAuth = "eSportsBookNonAuth", e.SportsBookOptions = "eSportsBookOptions", e.SportsNonAuth = "sports-non-auth", e.SwcAffiliateBonus = "swc-affiliate-bonus", e.SwcCashier = "swc-cashier", e.SwcCreditTime = "swc-credit-time", e.SwcDeposit = "swc-deposit", e.SwcDepositLimitButtonDisplay = "swc-depositlimit-button-display", e.SwcDepositMethodMinimum = "swc-deposit-method-minimum", e.SwcDepositReloader = "swc-deposit-reloader", e.SwcDispalyAutoConversionCTA = "swc-display-autoconversion-cta", e.SwcECheckConfirmation = "swc-eCheck-confirmation", e.SwcEmailVerification = "swc-email-verification", e.SwcExitFlow = "swc-exit-flow", e.SwcExploreCta = "swc-explore-cta", e.SwcManageCurrencies = "swc-manage-currencies", e.SwcMethodVerification = "swc-method-verification", e.SwcNewCashierNotification = "swc-new-cashier-notification", e.SwcOnboardingProgressbar = "swc-onboarding-progressbar", e.SwcP2pTransfer = "swc-p2ptransfer", e.SwcPaypalSandboxQA = "swc-paypal-sandbox-qa", e.SwcRMFPhoneVerification = "swc-rmf-phone-verification", e.SwcReloaderBonus = "swc-reloader-bonus", e.SwcRetryScreen = "swc-retry-screen", e.SwcRmfAddressSearch = "swc-rmf-address-search", e.SwcRmfFiscalCodeGenerator = "swc-rmf-fiscalcodegenerator", e.SwcRmfNoLimits = "swc-rmf-no-limits", e.SwcRmfShowOnlyWeeklyLimit = "swc-rmf-show-only-weekly-limit", e.SwcSGScreen = "swc-sg-screen", e.SwcSignup = "swc-signup", e.SwcSignupDeposit = "swc-signup-deposit", e.SwcSignupItChallengeQuestions = "swc-signup-it-challengequestions", e.SwcSignupOnePage = "swc-signup-onepage", e.SwcSignupPhoneCollection = "swc-signup-phone-collection", e.SwcSignupRmf = "swc-signup-rmf", e.SwcSignupRmfAutofocus = "swc-signup-rmf-autofocus", e.SwcSignupRmfEcoEransitionTwo = "swc-signup-rmf-ecotransitiontwo", e.SwcSignupRmfEcopokerLobby = "swc_signup_rmf_ecopokerlobby", e.SwcSignupRmfSumSub = "swc-signup-rmf-sumsub", e.SwcTransactionHistoryFilters = "swc-transaction-history-filters", e.SwcTurorial = "swc-tutorial", e.SwcWelcomeBonusScreen = "swc-welcomebonus-screen", e.SwcWithdrawal = "swc-withdrawal", e.SwcWithdrawalCreditTime = "swc-withdrawal-credit-time", e.SwcWithdrawalMethodMinimum = "swc-withdrawal-method-minimum", e.SwcXpayLibraryTestStatus = "swc-xpay-library-test-status", e.TemporaryLoginTimeLimit = "temporaryLoginTimeLimit", e.TheDeal = "the-deal", e.TheDealHighRoller = "the-deal-highroller", e.TwitchConnect = "TwitchConnect", e.UseRam1 = "UseRam1", e.VegasPanicButtonDialogNewText = "de-vegas-panic-button-dialog-new-text", e.VerificationRMOKCheck = "docverify-check-rmok", e.VerifyAccount = "verify-account", e.VerifyAccountAfterRmf = "verify-account-after-rmf", e.VerifyAccountDrivingLicense = "verify-account-driving-license", e.VerifyAccountNationalId = "verify-account-national-id", e.VerifyAccountPassport = "verify-account-passport", e.VerifyDoc = "verify-doc", e.VerifyWCSF = "verify-wcsf", e.VisibilityOASISExclusionOption = "visibility_OASIS_exclusion_option", e.VisibilityPlayingInsights = "Visibility_Playing_Insights", e.VisibilityPlayingInsightsLoginPopup = "Visibility_Playing_Insights_Login_popup", e.VisibilityRestrictWithdrawalCancellation = "visibility_restrict_withdrawal_cancellation", e.Wc2PlayMoney = "wc2-playmoney", e.WebMPCNotificationEnabled = "WebMPCNotificationEnabled", e.WebNotificationEnabled = "WebNotificationEnabled", e.WrmfAcAutotrigger = "wrmf-ac-autotrigger", e))(g || {}), dt = /* @__PURE__ */ ((e) => (e[e.NotBanned = 0] = "NotBanned", e[e.Banned = 1] = "Banned", e[e.Unbanned = 2] = "Unbanned", e[e.RemainBanned = 4] = "RemainBanned", e))(dt || {}), O = /* @__PURE__ */ ((e) => (e[e.COM = 0] = "COM", e[e.IT = 8] = "IT", e[e.FR = 16] = "FR", e[e.EE = 32] = "EE", e[e.BE = 64] = "BE", e[e.ES = 128] = "ES", e[e.DK = 256] = "DK", e[e.EU = 512] = "EU", e[e.USNJ = 2048] = "USNJ", e[e.UK = 4096] = "UK", e[e.BG = 8192] = "BG", e[e.DESH = 16384] = "DESH", e[e.RO = 65536] = "RO", e[e.PT = 131072] = "PT", e[e.CZ = 262144] = "CZ", e[e.IN = 524288] = "IN", e[e.ASIA = 1048576] = "ASIA", e[e.RU = 2097152] = "RU", e[e.USPA = 4194304] = "USPA", e[e.SE = 8388608] = "SE", e[e.CH = 16777216] = "CH", e[e.USMI = 16777220] = "USMI", e[e.NL = 16777221] = "NL", e[e.CAON = 16777222] = "CAON", e[e.GR = 16777250] = "GR", e[e.USCO = 16777218] = "USCO", e[e.DE = 16777219] = "DE", e))(O || {}), f = /* @__PURE__ */ ((e) => (e.ANJRGExclude = "anj-rg-exclude", e.ATSBaseUrl = "ats-api", e.ATSBootstrap = "ats-bootstrap", e.ATSCss = "ats-css", e.AboutRgCashierLogo = "about-rg-cashier-logo", e.AccountEmailValidationCode = "account-email-validation-code", e.AccountHistoryStatement = "account_history_statement", e.AccountPIN = "pokerstars-pin", e.AccountResponsible = "account-responsible", e.AddressChangeSupport = "address-change-support", e.AmountWithdrawHelp = "wdl-policy-general", e.AvailableWithdrawFaq = "available-withdraw-faq", e.BeGambleAwareLogo = "be-gamble-aware-logo", e.BonusWheelGame = "bonuswheel_game", e.BonusesReleaseAndInstant = "bonuses-release-and-instant", e.CAONRedirect = "caon_mob_redirect", e.CAONSignup = "caon_signup", e.CRMStarCode = "crm_starcode", e.CSPasswordReset = "cs-password-reset", e.CSResponsibleExclusion = "cs-responsible-exclusion", e.Cashbonus = "cashbonus", e.CasinoAssetWrapper = "casino-asset-wrapper", e.CasinoRedemption = "sr_casino_redemption", e.CasinoSlots = "casino-slots", e.ChestAssets = "chest_assets", e.CloseAccount = "cs-account-closure", e.CommunityForumBaseURL = "CommunityForumBaseURL", e.CommunityForumLoginURL = "communityforumcustomloginpageurl", e.ConnexOntario = "connex_ontario", e.ContactSupport = "contact-support", e.ContactSupportCashierTroubleDeposit = "contact-support-cashier-trouble-deposit", e.ContactSupportStella = "contact_support_stella", e.Cookies = "cookies", e.DFAccountResponsibleGaming = "about-rg-cashier-logo", e.DFSecuritySecurityDocumentRequest = "df_security_securitydocumentrequest", e.DKRegulatorLogo = "dk_dga_logo", e.Davos = "davos", e.EEPopulationRegister = "ee_population_register", e.EligibleEula = "eligible_eula", e.ExchangeHome = "exchange-home", e.ExchangeMybets = "exchange-mybets", e.ExchangeWhiteLabel = "exchange_white_label", e.FacebookSharer = "facebook_sharer", e.FailedPow = "failed-pow", e.FreeSpinBonus = "free-spins-bonuses", e.FreeSpinBonusTermsBonus = "freespinbonus_terms_bonus", e.FreeSpinBonusTermsBonusCap = "freespinbonus_terms_bonus_cap", e.FreeSpinBonusTermsCash = "freespinbonus_terms_cash", e.FreeSpinBonusTermsCashCap = "freespinbonus_terms_cash_cap", e.FreemiumBuyPlayChips = "freemium-buy-play-chips", e.GamCareHelplineLogo = "gamcare-helpline-logo", e.GambanUK = "gamban_uk", e.GambleAware = "gamble_aware", e.GamblerLogo800 = "800-gambler-logo", e.GamcareTest = "gamcare_rgtest", e.GameSecurity = "df_security_gamesecurity", e.GamingAccountAgreement = "gaming_account_agreement", e.GamingControlBoard = "gaming-control-board", e.GamingLabsLogo = "gaming-labs-logo", e.GeoAssist = "geo-assist", e.GordonMoodyLogo = "gordon-moody-logo", e.GrLimitNotIfPrompt = "gr-limitnotif-prompt", e.HcCurrencyMgt = "hc_currency_mgt", e.HcTransfersIssues = "hc-transfers-issues", e.HelpCenter = "help-center", e.HelpCenterAccVerif = "help-center-accverif", e.HelpCenterAccountValidation = "help_center_account_validation", e.HelpCenterChatBotScript = "hc-chat-bot-script", e.HelpCenterChatBotUrl = "hc-chat-bot-url", e.HelpCenterDepositDeletingUpdatingCardDetails = "hc-dep-deleting-updating-card-details", e.HelpCenterDepositWithdrawal = "hc_dep_wd", e.HelpCenterESDecree = "help-center-esdecree", e.HelpCenterFeedback = "hc-feedback", e.HelpCenterP2pTransfer = "hc_transf", e.HelpEmails = "help_emails", e.HelpFaqGeolocation = "help_faq_geolocation", e.HelpGameSportsRules = "help_games_sports_rules", e.HelpGamecare = "help_gamcare", e.HelpMGA = "help_mga", e.HelpMalta = "help_malta", e.HelpOver18 = "help_over18", e.HelpRGAccredation = "help_rg_accredation", e.HelpRGRegulatorSE = "help_rg_regulator_se", e.HelpRGSE = "help_rg_se", e.HelpResponsibleGaming = "help_responsiblegaming", e.HelpRestrictedAccount = "help-restricted-account", e.HelpSettingLimits = "help_setting_limits", e.HelpTOS = "help_tos", e.HelpUpdateDetails = "help_update_details", e.HomeGamesInvite = "homegames_invite", e.HorseRacingRules = "sportsbook-isp-horseracing-rules", e.IGamingOntario = "igaming-ontario", e.ISPFreeBets = "ispfreebets", e.IbasLogo = "ibas-logo", e.IbiaLogo = "ibia-logo", e.Ice2Home = "ice-home2", e.IceHome = "ice-home", e.IceLeaderboards = "ice-leaderboards", e.IdscanHostedUrl = "idscan-hosted-url", e.IdscanServerUrl = "idscan-server-url", e.InstantBonus = "instant-bonuses", e.InstantBonusSplitWagerTermsCash = "Instantbonus_splitwager_terms_cash", e.InstantBonusSplitWagerTermsCashCap = "Instantbonus_splitwager_terms_cash_cap", e.InstantBonusSplitwagerTermsCash = "instantBonus_splitwager_terms_cash", e.InstantBonusSplitwagerTermsCashCap = "instantbonus_splitwager_terms_cash_cap", e.InstantBonusTermsCash = "instantbonus_terms_cash", e.InstantBonusTermsCashCap = "instantbonus_terms_cash_cap", e.InstantBonusTermsPurchase = "instantbonus_terms_purchase", e.Joueurs = "joueurs", e.LiveChatSupport = "live-chat-support", e.LostRSAToken = "lost_rsa_token", e.MCEula = "mc_eula", e.MCEulaARStates = "mc_eula_ar_states", e.MCPrivacy = "mc_privacy", e.MCVipStore = "mc_vipstore", e.MTTGameFilters = "game-filters-template", e.MatchDayMillions = "matchdaymillions_game", e.MigrationWithdraw = "migration_withdraw", e.MinigameTicket = "mini-game-tickets", e.MitIDRedirect = "mitid-redirect", e.NJDgeLogo = "nj-dge-logo", e.NPSDismissal = "stars_nps_dismissal", e.NPSFollowUp = "stars_nps_follow_up", e.NPSSubmission = "stars_nps_submission", e.NwWithdrawRestricted = "nw-withdraw-restricted", e.ONJNLogo = "onjn-logo", e.OasisReinstate = "OASIS_reinstate", e.OpenBankidValidation = "open_bankid_validation", e.OrderRSAToken = "order-rsa-token", e.PACouncilLogo = "pa-council-logo", e.PMCPaywall = "pmc_paywall", e.PRMCasinoPromoTerms = "prm_casino_promo_terms", e.PRMCasinoRacesIngame = "prm_casino_races_ingame", e.PRMPSCasinoDownload = "prm_pscasino_download", e.PRMPowerPath = "prm_power_path", e.PSDownload = "ps-download", e.PSMessenger = "ps-messenger", e.PTBlacklist = "pt_blacklist", e.PanicButtonHelpArticle = "de-vegas-panic-button-help-article", e.PaymentInstrumentDocuments = "payment_instrument_documents", e.PickObjectGame = "pickobject_game", e.PlayTheDeal = "play-the-deal-webui", e.PlayerFundsProtection = "playerFundsProtection", e.PlayerLocationCheck = "player_location_check", e.PlayerProtectionPage = "player-protection-page", e.PlayingInsightsMvpSurvey = "playing_insights_mvp_survey", e.ProcessingExchangeTerms = "processing-exchange-terms", e.ProcessingTime = "hc-wd-processing-time", e.RG18Logo = "rg18-logo", e.RGNJOAG = "rg_njoag", e.RGPage = "mc_responsible", e.RGQuestion = "rg_question", e.RGRegulatorSE = "rg_regulator_se", e.RamConfig = "ram_config_url", e.RamCounselingCenter = "ram_counseling_center", e.RamGamblingTherapy = "ram_gambling_therapy", e.RamUtils = "ram_require_js", e.RealMoney = "realmoney", e.RealMoneyAgeVerificationFaq = "realmoney_ageverification_faq", e.RealMoneyEcheckTerms = "realmoney_echeck_terms", e.RealMoneyMuchBetterSignUp = "realmoney_muchbetter_signup", e.RealMoneyMuchBetterSignUpGdpr = "realmoney_muchbetter_signup_gdpr", e.RealMoneyPspayAstropayRate = "realmoney_pspay_astropay_rate", e.RealMoneyResortsCasino = "realmoney_resortscasino", e.RealMoneySecurityFaq = "realmoney_security_faq", e.ResortsLogo = "resorts-logo", e.ResponsibleGamingLogoBe = "responsible-gaming-logo-be", e.ResponsibleGamingPokerLimit = "responsible_gaming_poker_limit", e.ResponsibleGamingQuestion = "cs-responsible-question", e.RoWithHoldingTax = "ro-withholding-tax", e.Rollback = "hc-rollback", e.SaGGameRules = "game-rules-sag", e.SalLgo = "sal-logo", e.SecAccountRestricted = "sec_account_restricted", e.SecurityAgeVerification = "security-age-verification", e.SelfExclusionGamStop = "self-exclusion-gamstop", e.SelfExclusionInformation = "self-exclusion-information", e.SelfExclusionMerger = "self-exclusion-merger", e.SelfExclusionResponsibleGamingFT = "self-exclusion-rg-page-fulltilt", e.SelfExclusionResponsibleGamingPS = "self-exclusion-rg-page-ps", e.SicadPT = "sicad-pt", e.SingleReelGame = "singlereel_game", e.SolLgo = "sol-logo", e.SportsBookExchange = "sportsbook-exchange", e.SportsBookFreeBets = "sportsbook-freebets", e.SportsCashBonusTerms = "bonuscash-terms", e.SrijRIG = "srij-rig", e.StarCode = "star-code", e.StarsCrmCdnBaseUrl = "starscrm_cdn_baseurl", e.StarsRewardsWidgetService = "starsrewards_widgetservice", e.StarsWeb = "stars_web", e.StarsWebApi = "starsweb_api", e.StarsWebCasino = "starsweb_casino", e.StarsWebMinilobby = "starsweb_minilobby", e.StarsWebPoker = "starsweb_poker", e.StarsWebSports = "starsweb_sports", e.SubmitDocuments = "submit-documents", e.SubmitDocumentsVerifications = "submit-documents-verifications", e.SwcCallbackRedirect = "swc_callback_redirect", e.SwcContactSupportRestrictedAccount = "swc-contact-support-restricted-account", e.SwcManageCurrencies = "swc-manage-currencies", e.SwcSubmitDocumentsVerifications = "swc-submit-documents-verifications", e.SwcWithdrawalDecline = "swc-withdrawal-decline", e.TwitchAuthorize = "twitch_authorize", e.TwitterShare = "twitter_share", e.UKGamstopMain = "uk_gamstop_main", e.UKLicenseAccountNumber = "uk_license_account_number", e.VanillaDirectStoreLocator = "vanilla_direct_store_locator", e.VerifyMeAML = "verify-me-aml", e.WC2FEBalance = "wc2fe_balance", e.WC2FEConvertCurrencies = "wc2fe_convert_currencies", e.WC2FEDeposit = "wc2fe_deposit", e.WC2FEHistory = "wc2fe_history", e.WC2FEHome = "wc2fe_home", e.WC2FEPlayMoney = "wc2fe_playmoney", e.WC2FEPreferredCurrency = "wc2fe_preferred_currency", e.WebPoker = "web_poker", e.WebRealMoneyForm = "web-real-money-form", e.Withdrawal = "wc2fe_cashout", e.WrmfTelematiciFiscal = "wrmf_telematici_fiscal", e.XeWebSite = "xe_web_site", e))(f || {}), pe = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.Andorra = "AD", e.Argentina = "AR", e.Austria = "AT", e.Belgium = "BE", e.Brazil = "BR", e.Canada = "CA", e.Chile = "CL", e.Estonia = "EE", e.France = "FR", e.FrenchGuiana = "GF", e.Germany = "DE", e.Gibraltar = "GI", e.GreatBritain = "GB", e.Guadeloupe = "GP", e.Guernsey = "GG", e.India = "IN", e.Ireland = "IE", e.Italy = "IT", e.Jersey = "JE", e.Martinique = "MQ", e.Mayotte = "YT", e.Mexico = "MX", e.Netherlands = "NL", e.Peru = "PE", e.Reunion = "RE", e.Romania = "RO", e.Russia = "RU", e.Slovenia = "SI", e.Ukraine = "UA", e.UnitedStates = "US", e.Uruguay = "UY", e))(pe || {}), lt = /* @__PURE__ */ ((e) => (e.Grid = "grid", e.Table = "table", e))(lt || {}), ce = /* @__PURE__ */ ((e) => (e[e.SelfExcluded = 67108864] = "SelfExcluded", e[e.PrivPlay = 1] = "PrivPlay", e[e.PrivChat = 2] = "PrivChat", e))(ce || {}), ue = /* @__PURE__ */ ((e) => (e[e.SuspendRM = 32768] = "SuspendRM", e[e.CannotSendTransfer = 8] = "CannotSendTransfer", e))(ue || {}), x = /* @__PURE__ */ ((e) => (e[e.MailListPoker = 1] = "MailListPoker", e[e.MailListCasino = 2] = "MailListCasino", e[e.MailListSports = 4] = "MailListSports", e[e.SportLiveAlert = 1073741824] = "SportLiveAlert", e[e.WithdrawalCancellation = 8192] = "WithdrawalCancellation", e[e.NoWithdraw = 128] = "NoWithdraw", e[e.NoSportsPlay = 16] = "NoSportsPlay", e))(x || {}), j = /* @__PURE__ */ ((e) => (e[e.RealMoneyOk = 8] = "RealMoneyOk", e[e.AgeVerified = 4096] = "AgeVerified", e[e.AuthVerified = 1048576] = "AuthVerified", e[e.RSARequired = 67108864] = "RSARequired", e[e.AccountPINRequired = 536870912] = "AccountPINRequired", e))(j || {}), H = /* @__PURE__ */ ((e) => (e[e.ConvertBuyIn = 16] = "ConvertBuyIn", e[e.ConvertWinnings = 32] = "ConvertWinnings", e[e.NoLoginEmailNotification = 256] = "NoLoginEmailNotification", e[e.BannedByRegulator = 268435456] = "BannedByRegulator", e[e.AccountPINGenerated = 1] = "AccountPINGenerated", e[e.RSAActivated = 2] = "RSAActivated", e[e.PendingFunds = 1048576] = "PendingFunds", e[e.MobileVerified = 65536] = "MobileVerified", e))(H || {}), T = /* @__PURE__ */ ((e) => (e[e.OneTimePINRequired = 16777216] = "OneTimePINRequired", e[e.AMLVerified = 8] = "AMLVerified", e[e.AMLDocsInProgress = 16] = "AMLDocsInProgress", e[e.AMLSuspended = 32] = "AMLSuspended", e[e.AMLDepositThresholdReached = 64] = "AMLDepositThresholdReached", e[e.AMLShowVerifiedModal = 256] = "AMLShowVerifiedModal", e[e.KYCRequired = 16384] = "KYCRequired", e[e.VerifiedForMarketing = 32768] = "VerifiedForMarketing", e[e.VulnerablePlayer = 262144] = "VulnerablePlayer", e[e.LicenseMobileVerified = 65536] = "LicenseMobileVerified", e))(T || {}), ee = /* @__PURE__ */ ((e) => (e[e.Verified = 1] = "Verified", e[e.Bounced = 64] = "Bounced", e[e.NotAuthorized = 524288] = "NotAuthorized", e[e.AlwaysValidated = 262144] = "AlwaysValidated", e))(ee || {}), ge = /* @__PURE__ */ ((e) => (e.FoxBet = "FOX Bet", e.PokerStars = "PokerStars", e))(ge || {}), pt = /* @__PURE__ */ ((e) => (e[e.Blue = 1] = "Blue", e[e.Bronze = 2] = "Bronze", e[e.Silver = 3] = "Silver", e[e.Gold = 4] = "Gold", e[e.Diamond = 5] = "Diamond", e[e.Black = 6] = "Black", e))(pt || {}), u = /* @__PURE__ */ ((e) => (e[e.COM = 1] = "COM", e[e.NET = 2] = "NET", e[e.IT = 16] = "IT", e[e.FR = 32] = "FR", e[e.EE = 64] = "EE", e[e.BE = 512] = "BE", e[e.ES = 1024] = "ES", e[e.DK = 2048] = "DK", e[e.EU = 4096] = "EU", e[e.USNJ = 16384] = "USNJ", e[e.UK = 32768] = "UK", e[e.BG = 65536] = "BG", e[e.DESH = 131072] = "DESH", e[e.RO = 524288] = "RO", e[e.PT = 1048576] = "PT", e[e.CZ = 2097152] = "CZ", e[e.RUSO = 4194304] = "RUSO", e[e.RUSOPM = 8388608] = "RUSOPM", e[e.IN = 16777216] = "IN", e[e.ASIA = 33554432] = "ASIA", e[e.RU = 67108864] = "RU", e[e.USPA = 134217728] = "USPA", e[e.SE = 268435456] = "SE", e[e.CH = 536870912] = "CH", e[e.ARBA = 536870913] = "ARBA", e[e.USCO = 536870914] = "USCO", e[e.DE = 536870915] = "DE", e[e.USMI = 536870916] = "USMI", e[e.NL = 536870917] = "NL", e[e.CAON = 536870918] = "CAON", e[e.GR = 536870957] = "GR", e))(u || {}), _ = /* @__PURE__ */ ((e) => (e[e.PokerStars = 1] = "PokerStars", e[e.PokerStarsCasino = 2] = "PokerStarsCasino", e[e.BetStars = 4] = "BetStars", e[e.FullTilt = 64] = "FullTilt", e[e.Unknown = 128] = "Unknown", e[e.PokerStarsVegas = 256] = "PokerStarsVegas", e[e.FoxBet = 8192] = "FoxBet", e))(_ || {});
const R = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", gn = () => {
  try {
    return localStorage.setItem("localStorageTest", "true"), localStorage.removeItem("localStorageTest"), !0;
  } catch {
    return !1;
  }
}, Nn = gn(), te = (e, n) => {
  const t = Be(e);
  return (r, ...i) => {
    const s = n ? `%s ${r}` : r, o = n ? [`requestId ${n}`, ...i] : i;
    return t(s, ...o);
  };
};
var K = /* @__PURE__ */ ((e) => (e.Bridge = "stars:bridge", e.Embedded = "stars:embedded", e.Error = "stars:error", e.Frame = "stars:frame", e.GeoComply = "stars:geoComply", e.MockServer = "mock:server", e.Monitor = "stars:monitor", e.Request = "stars:request", e.RequestInfo = "stars:request:info", e.RgError = "rgError:sePT", e.SdkRequest = "sdk:request", e.SdkSocket = "sdk:socket", e.Socket = "stars:socket", e.VaderArgs = "vader:args", e.VaderCallback = "vader:callback", e.VaderManifest = "vader:manifest", e.VaderOneTrust = "vader:one-trust", e.VaderPage = "vader:page", e.VaderPreview = "vader:preview", e.VaderServer = "vader:server", e.VaderState = "vader:state", e.VaderWebsite = "vader:website", e.VaderWidget = "vader:widget", e.Wizard = "stars:wizard", e))(K || {});
const Pn = (e) => typeof e == "object", je = (e) => e.replace(/\?:(\w*)/g, ":$1?"), fe = (e) => {
  if (typeof e != "string")
    return e;
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, Dn = (e, n) => e.replace(new RegExp(`^/${n}(/.*)?$`), "$1"), wn = R && window.Cypress, mt = (e, n) => new RegExp(`^(/${n})?/embedded/modal/`).test(e) ? "/embedded/modal" : new RegExp(`^(/${n})?/embedded/`).test(e) ? "/embedded" : "", Et = (e, n) => e.replace(
  new RegExp(`^(/${n})?${mt(e, n)}(/.*)?$`),
  "$2"
), bn = (e, n) => /* @__PURE__ */ y.createElement(n, { href: `mailto:${e}` }, e), Ln = (e, n, t, r, i) => {
  let s, o;
  const c = ze.find(({ type: l }) => {
    const m = `contactUsText${Re(l)}Starsdomain`;
    return e === m;
  });
  c && (o = c.getEmail(t || "", r));
  const d = ze.find(({ type: l }) => {
    const m = `contactUsMail${Re(l)}Starsdomain`;
    return e === m || e === "contactUsMail" || n === m;
  });
  if (d) {
    const l = d.getEmail(t || "", r);
    s = bn(l, i);
  }
  return { emailLink: s, emailText: o };
}, ze = ["support", "security", "verification", "wecare"].map((e) => ({
  getEmail: (n, t) => `${e}@${!n || n === "starsdomain" ? t : n}`,
  type: e,
  resolve: `contactUsMail${Re(e)}Starsdomain`
}));
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var _t = Cn, Je = Tn, yn = Object.prototype.toString, se = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function Cn(e, n) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var t = {}, r = n || {}, i = r.decode || Mn, s = 0; s < e.length; ) {
    var o = e.indexOf("=", s);
    if (o === -1)
      break;
    var c = e.indexOf(";", s);
    if (c === -1)
      c = e.length;
    else if (c < o) {
      s = e.lastIndexOf(";", o - 1) + 1;
      continue;
    }
    var d = e.slice(s, o).trim();
    if (t[d] === void 0) {
      var l = e.slice(o + 1, c).trim();
      l.charCodeAt(0) === 34 && (l = l.slice(1, -1)), t[d] = kn(l, i);
    }
    s = c + 1;
  }
  return t;
}
function Tn(e, n, t) {
  var r = t || {}, i = r.encode || Bn;
  if (typeof i != "function")
    throw new TypeError("option encode is invalid");
  if (!se.test(e))
    throw new TypeError("argument name is invalid");
  var s = i(n);
  if (s && !se.test(s))
    throw new TypeError("argument val is invalid");
  var o = e + "=" + s;
  if (r.maxAge != null) {
    var c = r.maxAge - 0;
    if (isNaN(c) || !isFinite(c))
      throw new TypeError("option maxAge is invalid");
    o += "; Max-Age=" + Math.floor(c);
  }
  if (r.domain) {
    if (!se.test(r.domain))
      throw new TypeError("option domain is invalid");
    o += "; Domain=" + r.domain;
  }
  if (r.path) {
    if (!se.test(r.path))
      throw new TypeError("option path is invalid");
    o += "; Path=" + r.path;
  }
  if (r.expires) {
    var d = r.expires;
    if (!Un(d) || isNaN(d.valueOf()))
      throw new TypeError("option expires is invalid");
    o += "; Expires=" + d.toUTCString();
  }
  if (r.httpOnly && (o += "; HttpOnly"), r.secure && (o += "; Secure"), r.priority) {
    var l = typeof r.priority == "string" ? r.priority.toLowerCase() : r.priority;
    switch (l) {
      case "low":
        o += "; Priority=Low";
        break;
      case "medium":
        o += "; Priority=Medium";
        break;
      case "high":
        o += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (r.sameSite) {
    var m = typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite;
    switch (m) {
      case !0:
        o += "; SameSite=Strict";
        break;
      case "lax":
        o += "; SameSite=Lax";
        break;
      case "strict":
        o += "; SameSite=Strict";
        break;
      case "none":
        o += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return o;
}
function Mn(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function Bn(e) {
  return encodeURIComponent(e);
}
function Un(e) {
  return yn.call(e) === "[object Date]" || e instanceof Date;
}
function kn(e, n) {
  try {
    return n(e);
  } catch {
    return e;
  }
}
function Gn() {
  return typeof document == "object" && typeof document.cookie == "string";
}
function vn(e) {
  return typeof e == "string" ? _t(e) : typeof e == "object" && e !== null ? e : {};
}
function Se(e, n = {}) {
  const t = Vn(e);
  if (!n.doNotParse)
    try {
      return JSON.parse(t);
    } catch {
    }
  return e;
}
function Vn(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
class ft {
  constructor(n, t = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const i = this.cookies;
      this.cookies = _t(document.cookie), this._checkChanges(i);
    };
    const r = typeof document > "u" ? "" : document.cookie;
    this.cookies = vn(n || r), this.defaultSetOptions = t, this.HAS_DOCUMENT_COOKIE = Gn();
  }
  _emitChange(n) {
    for (let t = 0; t < this.changeListeners.length; ++t)
      this.changeListeners[t](n);
  }
  _checkChanges(n) {
    new Set(Object.keys(n).concat(Object.keys(this.cookies))).forEach((r) => {
      n[r] !== this.cookies[r] && this._emitChange({
        name: r,
        value: Se(n[r])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(n, t = {}) {
    return t.doNotUpdate || this.update(), Se(this.cookies[n], t);
  }
  getAll(n = {}) {
    n.doNotUpdate || this.update();
    const t = {};
    for (let r in this.cookies)
      t[r] = Se(this.cookies[r], n);
    return t;
  }
  set(n, t, r) {
    r ? r = Object.assign(Object.assign({}, this.defaultSetOptions), r) : r = this.defaultSetOptions;
    const i = typeof t == "string" ? t : JSON.stringify(t);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [n]: i }), this.HAS_DOCUMENT_COOKIE && (document.cookie = Je(n, i, r)), this._emitChange({ name: n, value: t, options: r });
  }
  remove(n, t) {
    const r = t = Object.assign(Object.assign({}, t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[n], this.HAS_DOCUMENT_COOKIE && (document.cookie = Je(n, "", r)), this._emitChange({ name: n, value: void 0, options: t });
  }
  addChangeListener(n) {
    this.changeListeners.push(n), this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(n) {
    const t = this.changeListeners.indexOf(n);
    t >= 0 && this.changeListeners.splice(t, 1), this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
var oe, Hn = new Uint8Array(16);
function Wn() {
  if (!oe && (oe = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !oe))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return oe(Hn);
}
const xn = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function qn(e) {
  return typeof e == "string" && xn.test(e);
}
var w = [];
for (var Ie = 0; Ie < 256; ++Ie)
  w.push((Ie + 256).toString(16).substr(1));
function Kn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = (w[e[n + 0]] + w[e[n + 1]] + w[e[n + 2]] + w[e[n + 3]] + "-" + w[e[n + 4]] + w[e[n + 5]] + "-" + w[e[n + 6]] + w[e[n + 7]] + "-" + w[e[n + 8]] + w[e[n + 9]] + "-" + w[e[n + 10]] + w[e[n + 11]] + w[e[n + 12]] + w[e[n + 13]] + w[e[n + 14]] + w[e[n + 15]]).toLowerCase();
  if (!qn(t))
    throw TypeError("Stringified UUID is invalid");
  return t;
}
function $n(e, n, t) {
  e = e || {};
  var r = e.random || (e.rng || Wn)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, n) {
    t = t || 0;
    for (var i = 0; i < 16; ++i)
      n[t + i] = r[i];
    return n;
  }
  return Kn(r);
}
var ht = /* @__PURE__ */ ((e) => (e.Login = "login", e.RefreshSession = "refreshSession", e.Registration = "registration", e.VerifySession = "verifySession", e))(ht || {});
const Ne = new ft(), Pe = () => {
  const e = "server";
  let n = Ne.get(z.INSTALL_ID);
  return !n && R && (n = process.env.NODE_ENV === "test" ? "testInstallId" : $n().split("-").map((t) => parseInt(t, 36)).map((t) => t.toString()).join("").slice(0, 18).toUpperCase(), Ne.set(z.INSTALL_ID, n, {
    domain: window.location.hostname.split(".").slice(1).join("."),
    path: "/"
  })), n ? { installId: n, authSource: e } : { authSource: e };
}, Yn = {
  response: (e, { account: n, ...t }) => ({
    ...e,
    ...Pe(),
    ...t,
    authSource: "client"
  }),
  update: (e, n) => ({
    ...Pe(),
    ...e,
    ...n
  }),
  clear: ({ authSource: e, installId: n }) => ({ authSource: e, installId: n }),
  "persist/REHYDRATE": (e, n = { session: {} }) => ({
    ...e,
    ...n.session
  })
}, Qn = (e, n) => ({
  get() {
    return e;
  },
  getJWTValues() {
    return n(e, ({ token: t }) => {
      try {
        return Vt(t);
      } catch {
        return;
      }
    });
  },
  getLegacySession() {
    return n(
      e,
      (t) => a.session.getJWTValues(t),
      ({ token: t, signature: r, userWebId: i }, s) => s ? {
        token: s.token,
        signature: Ne.get(z.SIGNATURE),
        userWebId: s.webId
      } : { token: t, signature: r, userWebId: i }
    );
  },
  getWebId() {
    return n(
      (t) => a.session.getLegacySession(t),
      ({ userWebId: t }) => t
    );
  },
  hasClientSession() {
    return e(({ authSource: t }) => t === "client");
  },
  /**
   * Determines if the client has a validated session token.
   * Will always be false for SSR and for first client render
   */
  isClientAuthenticated() {
    return n(
      (t) => a.session.getLegacySession(t),
      ({ token: t }) => !!t
    );
  },
  /**
   * Determines if the user has a session token, which may not be validated.
   * May be true for SSR and first client render
   * Use "isClientAuthenticated" if you need to know the session has been validated.
   */
  isAuthenticated() {
    return n(
      e,
      (t) => a.session.isClientAuthenticated(t),
      ({ serverAuth: t }, r) => t || r
    );
  },
  isAuthenticationCheckComplete() {
    return n(
      e,
      (t) => a.session.isClientAuthenticated(t),
      ({ serverAuth: t }, r) => t === r
    );
  },
  isFirstAuthenticatedSession() {
    return e(
      ({ loginSource: t }) => t === "registration"
      /* Registration */
    );
  },
  isServerAuthenticated() {
    return e(({ serverAuth: t, authSource: r }) => !!t && r === "server");
  }
}), jn = {
  state: Pe(),
  reducers: Yn,
  selectors: Qn
}, zn = (e, n) => ({
  get() {
    return e;
  },
  getUserId() {
    return e((t) => t.userId);
  },
  getGamingAccountNumber() {
    return e((t) => t.gamingAccountNumber);
  },
  getCity() {
    return e((t) => t.city);
  },
  getAddress() {
    return e((t) => t.addr1);
  },
  getAccValEventType() {
    return e((t) => t.accValEventType);
  },
  getBuildingNumber() {
    return e((t) => t.buildingNumber);
  },
  getStreetName() {
    return e((t) => t.streetName);
  },
  getDateOfBirth() {
    return e((t) => t.dateOfBirth ? new Date(t.dateOfBirth) : void 0);
  },
  getNationalDocumentNumber() {
    return e((t) => t.nationalDocumentNumber);
  },
  getZipCode() {
    return e((t) => t.zipCode);
  },
  getFirstName() {
    return e((t) => t.firstName);
  },
  getLastName() {
    return e((t) => t.lastName);
  },
  getFullName() {
    return e((t) => t.fullName);
  },
  getGender() {
    return e((t) => t.gender);
  },
  getPlaceOfBirth() {
    return e((t) => t.placeOfBirth);
  },
  getOrientationNumber() {
    return e((t) => t.orientationNumber);
  },
  getDistrict() {
    return e((t) => t.district);
  },
  getPartOfMunicipality() {
    return e((t) => t.partOfMunicipality);
  },
  getRegistrationDate() {
    return e((t) => t.registered ? new Date(t.registered) : void 0);
  },
  // TODO: Add getFullPlaceOfBirth when we have states.json and countries.json
  getEulaAcceptanceDate() {
    return e((t) => t.eulaSigned ? new Date(t.eulaSigned) : void 0);
  },
  getEmail() {
    return e((t) => t.email);
  },
  getAddressState() {
    return e((t) => t.state);
  },
  // TODO: Add getFullAddress when we have states.json and countries.json
  getAccountSummary() {
    return e((t) => t.accountSummary);
  },
  getAmlEventType() {
    return e((t) => t.amlEventType);
  },
  getAmlDaysLeft() {
    return e((t) => t.amlDaysLeft);
  },
  getAmlDepositThresholdReachedTimestamp() {
    return e((t) => t.amlDepositThresholdReachedTimestamp);
  },
  getBalances() {
    return e((t) => t.balances);
  },
  getTotalBalance() {
    return e((t) => t.totalBalance);
  },
  getTotalBalanceInUsd() {
    return e((t) => t.totalBalanceInUsd);
  },
  getPlayChips() {
    return e((t) => t.playChips);
  },
  getLastLoginDetails() {
    return e((t) => q(t, "info.lastLoginDetails", {}));
  },
  getSessionWinLossData() {
    return e((t) => q(t, "info.sessionWinLossData", {}));
  },
  getLoginLimitInfo() {
    return e((t) => q(t, "info.loginLimitInfo", {}));
  },
  getCommunicationPreferences() {
    return e((t) => {
      const r = t.privileges3?.lo;
      return {
        mailListPoker: (r & x.MailListPoker) === 0,
        mailListCasino: (r & x.MailListCasino) === 0,
        mailListSports: (r & x.MailListSports) === 0,
        liveAlertSport: (r & x.SportLiveAlert) === 0
      };
    });
  },
  getMultiCurrencyPreferences() {
    return e((t) => {
      const r = t.flags2?.lo;
      return {
        convertBuyIns: (r & H.ConvertBuyIn) !== 0,
        convertWinnings: (r & H.ConvertWinnings) !== 0
      };
    });
  },
  getPreferredCurrencyBalance() {
    return e((t) => t.balances?.[0]?.chips);
  },
  getCurrency() {
    return e((t) => t.balances?.[0]?.currency);
  },
  getSelfExclusion() {
    return e((t) => (t.privileges & ce.SelfExcluded) !== 0);
  },
  isSportsSelfExcluded() {
    return n(
      this.getSelfExclusion,
      (t) => a.cms.getBrandId(t) === _.BetStars,
      (t, r) => r && t
    );
  },
  getOccupationInfo() {
    return e((t) => t.occupationInfo);
  },
  getOddsFormat() {
    return e((t) => t.oddsFormat);
  },
  hasAutoAcceptEnabled() {
    return e((t) => t.autoAcceptPriceChanges);
  },
  getPhone() {
    return e((t) => t.phone);
  },
  getMobilePhone() {
    return e((t) => t.mobilePhone);
  },
  isMobileVerified() {
    return e((t) => !!(t.flags2?.lo & H.MobileVerified));
  },
  isLicenseMobileVerified() {
    return e((t) => !!(t.flags3?.lo & T.LicenseMobileVerified));
  },
  getCountry() {
    return e((t) => t.country);
  },
  getLicense() {
    return e((t) => t.licenseId);
  },
  getTimezone() {
    return e((t) => t.timezone);
  },
  getEulaMarketingEnabled() {
    return e((t) => !!t.signEulaOptions && (t.signEulaOptions & 1) === 1);
  },
  getForcedCashoutEnabled() {
    return e((t) => !!t.forcedCashout);
  },
  getBanPopup() {
    return e((t) => t.banPopUp || dt.NotBanned);
  },
  getDepositConfirmLimits() {
    return e((t) => {
      const { depositConfirmLimits: r } = t;
      return r?.length ? r : null;
    });
  },
  getGameConfirmLimits() {
    return e((t) => {
      const { gameConfirmLimits: r } = t;
      return r?.length ? r : null;
    });
  },
  getEmailValidationFlags() {
    return e((t) => {
      const r = t.flags, i = t.flags2?.hi;
      return {
        verified: !!(r & ee.Verified),
        bounced: !!(r & ee.Bounced),
        notAuthorized: !!(i & ee.NotAuthorized),
        alwaysValidated: !!(i & ee.AlwaysValidated)
      };
    });
  },
  getStarsCoinBalance() {
    return e((t) => Math.floor((t.fppAmount || 0) / 100));
  },
  getDefaultCurrencyForCountry() {
    return e((t) => t.defaultCurrencyForCountry);
  },
  getInfoSelfExcludedMessage() {
    return e((t) => t.infoSelfExclMsg);
  },
  getSelfExclusionExpirationDate() {
    return e((t) => t.selfExclusionExpirationDate);
  },
  hasPendingFunds() {
    return e((t) => !!(t.flags2?.lo & H.PendingFunds));
  },
  isAccountCancelled() {
    return e((t) => {
      const { privileges: r, privileges2: i, flags: s, licenseId: o, esCitizenOrResident: c } = t;
      return (r & ce.PrivPlay) === 0 && (r & ce.PrivChat) === 0 && (s & j.AuthVerified) === 0 && !!(i && i.hi & ue.SuspendRM) && c === !1 && [O.ES].includes(o);
    });
  },
  isWithdrawalCancellationRestricted() {
    return e(
      (t) => !!(t.privileges3?.lo & x.WithdrawalCancellation)
    );
  },
  noWithdraw() {
    return e((t) => !!(t.privileges3?.hi & x.NoWithdraw));
  },
  accountDetailsRequired() {
    return e((t) => q(t, "info.confirmAccountDetails", !1));
  },
  isAgeVerified() {
    return e((t) => !!(t.flags & j.AgeVerified));
  },
  isAuthVerified() {
    return e((t) => !!(t.flags & j.AuthVerified));
  },
  isVulnerablePlayer() {
    return e((t) => !!((t.flags3?.hi ?? 0) & T.VulnerablePlayer));
  },
  isVerifiedForMarketing() {
    return e((t) => !!((t.flags3?.hi ?? 0) & T.VerifiedForMarketing));
  },
  bannedByRegulator() {
    return e((t) => (t.flags2?.lo & H.BannedByRegulator) !== 0);
  },
  RSAActivated() {
    return e((t) => !!(t.flags2?.lo & H.RSAActivated));
  },
  RSATokenEnabled() {
    return e((t) => !!(t.flags & j.RSARequired));
  },
  getTimestamp() {
    return e((t) => t.timestamp);
  },
  isEmailValidated() {
    return n(
      this.getEmailValidationFlags,
      ({ verified: t, notAuthorized: r, alwaysValidated: i }) => !(!t || r || i)
    );
  },
  getDefaultCurrency() {
    return n(
      this.getLicense,
      (t) => a.cms.showVegasContent(t),
      (t) => a.currency.getRealMoney(t),
      (t, r, i) => r || t === O.GR ? P.Euro : i
    );
  },
  getUserLimits() {
    return e((t) => t.userLimits);
  },
  isAccountPINEnabled() {
    return e((t) => !!(t.flags & j.AccountPINRequired));
  },
  isAccountPINGenerated() {
    return e((t) => !!(t.flags2?.lo & H.AccountPINGenerated));
  },
  isOneTimePINEnabled() {
    return e((t) => !!(t.flags3?.lo & T.OneTimePINRequired));
  },
  isMigrationRequired() {
    return e((t) => !!t.migrationFlag);
  },
  isQuickAccountCreationRequired() {
    return n(
      e,
      (t) => a.cms.getSiteId(t),
      ({ migrationFlag: t, migrationTarget: r }, i) => !!t && !!r && [u.USMI, u.USPA].includes(i) && [u.USMI, u.USPA].includes(r) && (t & 8) === 8
    );
  },
  isEulaRequired() {
    return e((t) => t.eulaRequired);
  },
  isRealMoneyOK() {
    return e((t) => !!(t.flags && t.flags & j.RealMoneyOk));
  },
  isCasinoRealityCheckRequired() {
    return e((t) => t.info ? t.info.casinoRealityCheck === null : !1);
  },
  isNoSportsPlay() {
    return e((t) => !!(t.privileges3?.lo & x.NoSportsPlay));
  },
  isSuspendRM() {
    return e(
      (t) => !!(t.privileges2 && t.privileges2.hi & ue.SuspendRM)
    );
  },
  suspendRmReasonVerification() {
    return e((t) => t.suspendRMReasons === vt.DOC_VERIFICATION);
  },
  cannotSendTransfer() {
    return e(
      (t) => !!(t.privileges2 && t.privileges2.lo & ue.CannotSendTransfer)
    );
  },
  loginEmailNotificationEnabled() {
    return e((t) => !(t.flags2?.hi & H.NoLoginEmailNotification));
  },
  isAgeVerificationRequired() {
    return e((t) => !!t.playerVerification);
  },
  isPasswordWeak() {
    return e((t) => !!t.passwordWeak);
  },
  showUkaYoungUserDialog() {
    return e((t) => !!t.showUkaYoungUserDialog);
  },
  showReinstateDialog() {
    return e((t) => !!t.showReinstateDialog);
  },
  dataIntegrityCheckFailed() {
    return e((t) => !!t.dataIntegrityCheckFailed);
  },
  displayValueProposition() {
    return e((t) => !!t.displayValueProposition);
  },
  amlVerified() {
    return e((t) => !!(t.flags3?.hi & T.AMLVerified));
  },
  amlDepositThresholdReached() {
    return e(
      (t) => !!(t.flags3?.hi & T.AMLDepositThresholdReached)
    );
  },
  amlDocsInProgress() {
    return e((t) => !!(t.flags3?.hi & T.AMLDocsInProgress));
  },
  amlSuspended() {
    return e((t) => !!(t.flags3?.hi & T.AMLSuspended));
  },
  amlShowVerifiedModal() {
    return e((t) => !!(t.flags3?.hi & T.AMLShowVerifiedModal));
  },
  disableFormUS() {
    return n(
      this.getSelfExclusion,
      this.getLicense,
      (t, r) => [O.USPA, O.USMI, O.USNJ].includes(r) && t
    );
  },
  isEUDE() {
    return n(
      this.getCountry,
      (t) => a.cms.getSiteId(t),
      (t, r) => r === u.EU && t === pe.Germany
    );
  },
  requireDocumentValidation() {
    return n(
      this.getDateOfBirth,
      this.isAuthVerified,
      this.isRealMoneyOK,
      this.isAgeVerified,
      (t) => a.cms.getSiteId(t),
      (t) => a.country.getCountry(t),
      (t) => t.feature?.[g.DocumentsRequestPrompt],
      (t, r, i, s, o, c, d) => o === u.EU && c === pe.Netherlands ? !!t && !i : d && r && i && !s
    );
  },
  addressChangeNotAllowed() {
    return n(
      this.getSelfExclusion,
      this.getLicense,
      this.bannedByRegulator,
      this.isSuspendRM,
      (t, r, i, s) => t && [O.USNJ, O.USPA, O.USMI].includes(r) || r === O.USMI && (i || s)
    );
  },
  isReloader() {
    return e((t) => !!t.reloader);
  },
  tempAccount() {
    return e((t) => !!t.tempAccount);
  },
  isSelfExcluded() {
    return e((t) => !!t.selfExcluded);
  },
  selfExclusionExpired() {
    return e((t) => !!t.selfExclusionExpired);
  },
  isVerifyWithdrawalMethod() {
    return e((t) => !!t.verifyWithdrawalMethod);
  },
  getWebClientDialog() {
    return e((t) => t.webClientDialog);
  },
  getNetDepositLimitGroup() {
    return e((t) => t.netDepositLimitGroup);
  },
  getAckLifetimeLimit() {
    return e((t) => t.lifetimeLimitAckLifetimeLimit);
  },
  checkLifetimeLimitAck() {
    return e((t) => !!t.lifetimeLimitAckAction);
  },
  getLifetimeLimitAckType() {
    return e((t) => t.lifetimeLimitAckTypeOfPopUp);
  },
  getUserIntId() {
    return e((t) => t.userIntId);
  },
  isDormantAccount() {
    return e((t) => !!t.dormantSuspended);
  },
  isEsCitizenOrResident() {
    return e((t) => !!t.esCitizenOrResident);
  },
  shouldPreventLogin() {
    return e((t) => !!t.preventLogin);
  },
  getDepositLimitPath() {
    return n(
      (t) => a.cms.getSiteId(t),
      (t) => `/account/responsible/restrict-deposit-limit${fi.includes(t) ? "-extended" : ""}`
    );
  },
  isTemporaryAccount() {
    return n(
      this.isRealMoneyOK,
      this.isAgeVerified,
      this.getAccountSummary,
      (t, r, i) => t && !r && !!i.type && [
        qe.DOC_VERIFICATION_REQUIRED,
        qe.RM_ACTIVITY_RESTRICTED
      ].includes(i.type)
    );
  },
  getPlayerValPopupType() {
    return e((t) => t.playerValPopupType);
  },
  isKYCRequired() {
    return e((t) => !!(t.flags3?.hi & T.KYCRequired));
  },
  pendingVerification() {
    return n(
      this.isKYCRequired,
      this.isAuthVerified,
      this.isRealMoneyOK,
      this.isAgeVerified,
      (t) => a.cms.getSiteId(t),
      (t, r, i, s, o) => o === u.CAON && !t && (!r || !i || !s)
    );
  },
  isRomanianTemporaryAccount() {
    return n(
      this.getLicense,
      this.isRealMoneyOK,
      this.isAgeVerified,
      this.isAuthVerified,
      (t, r, i, s) => t === O.RO && r && (!i || !s)
    );
  },
  showCashierTour() {
    return n(
      (t) => a.session.isAuthenticated(t),
      (t) => t.feature?.[g.SwcNewCashierNotification],
      (t, r) => t && r
    );
  },
  isLimitedAccount() {
    return n(
      this.getLicense,
      this.isRealMoneyOK,
      this.isAgeVerified,
      this.isAuthVerified,
      (t, r, i, s) => [O.RO, O.IT, O.CZ, O.FR].includes(t) ? r && (!i || !s) : t === O.ES ? r && s && !i : !1
    );
  },
  getMigrationTarget() {
    return e((t) => t.migrationTarget);
  },
  shouldOpenRmf() {
    return n(
      this.isKYCRequired,
      this.isAgeVerificationRequired,
      this.dataIntegrityCheckFailed,
      (t) => t.feature[g.DisableNewUkAgeVerificationFlow],
      (t) => t.feature[g.WrmfAcAutotrigger],
      (t, r) => r,
      (t, r, i, s, o, c) => !t && (!s && r || i || o && c === ht.Registration)
    );
  },
  isUSLicense() {
    return n(
      this.getLicense,
      (t) => [O.USMI, O.USNJ, O.USPA, O.USCO].includes(t)
    );
  },
  monthlyNetDepositLimit() {
    return e((t) => t.monthlyNetDepositLimit);
  },
  netDepositLimitCurrency() {
    return e((t) => t.netDepositLimitCurrency);
  },
  isSWCWithdraw() {
    return n(
      (t) => t.feature?.[g.SwcWithdrawal],
      (t) => !!t
    );
  },
  isSWCTransactionHistory() {
    return n(
      (t) => t.feature?.[g.SwcCashier],
      (t) => !!t
    );
  },
  isSWCManageCurrencies() {
    return n(
      (t) => t.feature?.[g.SwcManageCurrencies],
      (t) => !!t
    );
  },
  isSWCP2pTransfer() {
    return n(
      (t) => t.feature?.[g.SwcP2pTransfer],
      (t) => !!t
    );
  },
  isSWCCashierHome() {
    return n(
      (t) => t.feature?.[g.SwcCashier],
      (t) => !!t
    );
  },
  isSWCDevelop() {
    return n(
      this.isReloader,
      (t, r) => {
        const { feature: i } = t;
        return {
          hspSwcDeposit: i?.[g.SwcDeposit],
          hspSwcSignupDeposit: i?.[g.SwcSignupDeposit],
          hspSwcDepositReloader: i?.[g.SwcDepositReloader],
          rmfPassed: r
        };
      },
      (t, { rmfPassed: r, hspSwcDeposit: i, hspSwcSignupDeposit: s, hspSwcDepositReloader: o }) => !!(r && s) || !!i && !t || !!(i && t && o)
    );
  },
  isSWCDeposit() {
    return n(
      this.isReloader,
      (t, r) => {
        const { feature: i } = t;
        return {
          hspSwcDeposit: i?.[g.SwcDeposit],
          hspSwcSignupDeposit: i?.[g.SwcSignupDeposit],
          hspSwcDepositReloader: i?.[g.SwcDepositReloader],
          rmfPassed: r
        };
      },
      (t, { rmfPassed: r, hspSwcDeposit: i, hspSwcSignupDeposit: s, hspSwcDepositReloader: o }) => !!(r && s) || !!i && !t || !!(i && t && o)
    );
  },
  hideBonusCode() {
    return e((t) => !!(t.flags3?.hi & T.VulnerablePlayer));
  },
  getLugasPlayerStatusLastAckDate() {
    return e((t) => t.lugasPlayerStatus?.lastAcknowledgementDate ? new Date(t.lugasPlayerStatus?.lastAcknowledgementDate) : null);
  },
  allowHistoryAuditReport() {
    return n(
      this.getLicense,
      (t) => [O.USNJ, O.USMI, O.USPA].includes(t)
    );
  },
  allowAccountReopeningRequest() {
    return n(
      (t) => a.cms.getSiteId(t),
      (t) => ![u.ES, u.SE, u.RO, u.BE, u.CZ, u.EE, u.BG].includes(t)
    );
  },
  isDeAnnualAttestation() {
    return n(
      e,
      (t) => a.cms.getSiteId(t),
      ({ accValEventType: t }, r) => u.DE === r && t === xe.WAIT_ANN_ATT
    );
  },
  isDeAttestationSuspended() {
    return n(
      e,
      (t) => a.cms.getSiteId(t),
      ({ accValEventType: t }, r) => u.DE === r && t === xe.SUSPENDED_BY_ANN_ATT
    );
  },
  isRetryScreenPassed() {
    return e((t) => !!t.isRetryScreenPassed);
  }
}), Jn = {
  "session/clear": () => St.state,
  "session/response": (e, n) => n.account || e,
  update: (e, n) => ({ ...e, ...n })
}, St = {
  state: {},
  effects: On,
  reducers: Jn,
  selectors: zn
}, Xn = {
  layout_type: "StarsLayout",
  background_image: void 0,
  background_color: "",
  background_fit: null
}, Zn = {
  timeout: 2e4,
  retry: {
    count: 3
  }
}, Fn = {
  async fetchWebsite(e, { request: n, dispatch: t, rootState: r }) {
    const i = er(a.location.getHref(r), r);
    i.siteId === "isp" && delete i.siteId;
    const [{ body: s }, { body: o }] = await Promise.all([
      n({
        service: "/api/v1-preview/cms/website",
        ...Zn
      }),
      // TODO: CMS-migration - remove request to routes after all verticals are on ContentStack
      n({
        service: "/api/v1-preview/cms/routes",
        body: i
      })
    ]);
    if (s) {
      if (!s.website.legal_age) {
        const {
          body: { legalAge: d }
        } = await n({ service: "session.info" });
        s.website.legal_age = d;
      }
      const c = Object.fromEntries(
        Object.entries(o).map(([d, l]) => [
          Ct(d),
          l.replace("/casino/help/", "/help/")
        ])
      );
      s.aliases = {
        ...c,
        ...s.aliases
      };
    }
    t.cms.update(s);
  }
  // TODO: Add fetchPage, loadModel, prepare, preload when they are required.
}, er = (e, n) => {
  const t = new W(e, !0), { pathname: r, query: i } = t, s = a.location.stripBaseURL(n, r), o = a.location.getQuery(n), c = i.siteId || o.siteId, { clientVersion: d } = a.localSettings.get(n);
  return {
    path: s,
    clientVersion: R ? window.version : d,
    siteId: c
  };
}, tr = {
  [_.PokerStars]: "PS",
  [_.PokerStarsCasino]: "SC",
  [_.BetStars]: "BS",
  [_.FullTilt]: "FT",
  [_.PokerStarsVegas]: "VS",
  [_.FoxBet]: "FXB"
}, nr = {
  [_.PokerStarsCasino]: "PokerStars Casino",
  [_.BetStars]: "PokerStars Sports"
}, rr = (e, n) => ({
  enableOptimizely() {
    return n(
      e,
      (t) => a.cms.getToken(t, "OptimizelyPaths"),
      (t) => a.location.getPathname(t),
      ({ website: t, page: r }, i, s) => r?.enable_optimizely || !i ? !!r?.enable_optimizely : new RegExp(i).test(s)
    );
  },
  getAlternateLinks() {
    return n(
      (t) => a.cms.getWebsite(t),
      (t) => a.location.stripPrefix(t),
      (t, r) => t?.alternate_links?.filter(({ link: { excluded_paths: i } }) => {
        if (i?.length) {
          const s = i.map((c) => c.path.replace(/(^\/)|(\/$)/g, "")).join("|");
          return !new RegExp(`^/(${s})/.*`, "g").test(r);
        }
        return !0;
      })?.map(({ link: { locale_code: i, base_url: s, replaced_path_start: o } }) => {
        const c = o?.path_start_to_replace && o?.new_path_start ? r.replace(
          new RegExp(`^${o.path_start_to_replace}`),
          o.new_path_start
        ) : r;
        return {
          localeCode: i,
          url: `${s}${c}`
        };
      })
    );
  },
  getWebSiteBrandName() {
    return n(
      (t) => a.cms.getWebsite(t),
      (t) => t?.brand || "Unknown"
    );
  },
  getWebsiteBrandId() {
    return n(
      (t) => a.cms.getWebSiteBrandName(t),
      (t) => _[t]
    );
  },
  getPathBrandId() {
    return n(
      (t, r) => r,
      (t) => a.cms.getWebsiteBrandId(t),
      (t) => a.location.stripBaseURL(t, void 0),
      (t) => a.cms.getSiteId(t),
      (t, r, i, s) => {
        const o = t ?? i;
        if ([
          _.BetStars,
          _.PokerStars,
          _.PokerStarsCasino,
          _.PokerStarsVegas
        ].includes(r))
          switch (!0) {
            case o.startsWith("/poker/"):
              return _.PokerStars;
            case (o.startsWith("/vegas/") && (s === u.DE || s === u.DESH)):
              return _.PokerStarsCasino;
            case o.startsWith("/vegas/"):
              return _.PokerStarsVegas;
            case o.startsWith("/casino/"):
              return _.PokerStarsCasino;
            case o.startsWith("/sports/"):
              return _.BetStars;
          }
        return r;
      }
    );
  },
  getBrandId() {
    return n(
      e,
      (t) => a.cms.getWebsiteBrandId(t),
      ({ pathBrand: t }, r) => t || r
    );
  },
  getPathBrandName() {
    return n(
      e,
      (t) => a.cms.getWebsiteBrandId(t),
      ({ pathBrand: t }) => _[t] || _[_.PokerStars]
    );
  },
  getBrandName() {
    return n(
      this.getBrandId,
      (t) => nr[t] ?? Me(_)[t]
    );
  },
  getBrandCode() {
    return n(
      (t) => a.cms.getBrandId(t),
      (t) => tr[t]
    );
  },
  getCacheControl() {
    return e((t) => t.cacheControl);
  },
  getCanonicalLink() {
    return e((t) => t.website?.canonical_link);
  },
  getContent() {
    return e(({ content: t }) => t);
  },
  getContentItem() {
    return n(
      (t) => a.cms.getContent(t),
      (t, r) => r,
      (t, r) => t[r]
    );
  },
  getSEO() {
    return n(
      (t) => a.cms.getPage(t),
      (t) => a.cms.getContent(t),
      (t, r) => {
        const i = t?.content[0].seo;
        return i?.length ? r[i[0].uid] : void 0;
      }
    );
  },
  getDomain() {
    return n(
      e,
      (t) => a.location.getHostname(t),
      ({ website: t }, r) => t?.domains.find((i) => r.startsWith(i)) || t?.domains[0]
    );
  },
  getLegalAge() {
    return e(({ website: t }) => t?.legal_age);
  },
  getNotificationSubscriptionPath() {
    return n(
      (t) => a.locale.get(t),
      (t) => a.device.getId(t),
      (t) => a.account.getLicense(t),
      (t) => a.account.getUserId(t),
      (t) => a.cms.getSiteId(t),
      (t, r, i, s, o) => `/user/queue/starsweb/notifications/${t}/${r}/${i}/${o}/${s}`
    );
  },
  getFaviconURL() {
    return e((t) => t.website?.favicon?.url);
  },
  getPage() {
    return e((t) => t.page);
  },
  getPageTitle: () => n(
    (t) => a.cms.getSEO(t)?.title,
    (t) => a.cms.getPage(t)?.title,
    (t, r) => t ?? r
  ),
  getPageLoading() {
    return e((t) => R && !t.pageLoaded);
  },
  getRedirect() {
    return e((t) => t.redirect);
  },
  getRedirectTarget() {
    return e(({ redirect: t, content: r }) => {
      const i = t?.website;
      if (t?.to)
        return t.to;
      if (i?.length)
        return r[i[0].uid].domains[0];
    });
  },
  getGeoRedirect() {
    return e((t) => t.geo_redirect);
  },
  getGeoRedirectTarget() {
    return n(
      e,
      (t) => a.location.getProtocol(t),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      ({ geo_redirect: t, content: r }, i) => {
        const s = t?.redirect_website, o = t?.to_page;
        if (s?.length)
          return new W("").set("protocol", i).set("hostname", r[s[0].uid].domains[0]).set("pathname", o?.length ? r[o[0]?.uid].url : "").href;
      }
    );
  },
  getRegion() {
    return e((t) => t.website?.region || void 0);
  },
  /**
   * @deprecated For backported API compatibility only. Use `bindRequest` instead.
   */
  getRequestOptions() {
    return n(
      (t) => a.cms.getWebsite(t),
      (t) => a.cms.getWebsiteBrandId(t),
      (t) => a.cms.getSiteId(t),
      (t) => a.cms.getRegion(t),
      (t) => a.country.getCountry(t),
      (t) => a.device.getPlatform(t),
      (t) => a.device.get(t),
      (t) => a.currency.get(t),
      (t) => a.locale.get(t),
      (t) => a.session.get(t),
      (t) => a.location.getHref(t),
      (t) => a.location.getOrigin(t),
      (t) => a.location.getHost(t),
      (t) => a.system.get(t),
      (t, r, i, s, o, c, { device: d, os: l, embedded: m }, p, E, N, D, C, v, A) => {
        const S = { locale: E, currency: p, systemState: A }, I = {
          referer: D,
          "x-fi-ps-platform-id": `${c}`
        };
        return R || (t && Object.assign(S, { site: i, brand: r }), Object.assign(S, {
          device: d,
          country: o,
          os: l,
          embedded: m ? 1 : 0
        }), I["x-forwarded-host"] = v, I.origin = C, s && (S.region = s)), N.token && (I.authorization = `StarsWeb-Session ${N.token}`), { meta: S, headers: I };
      }
    );
  },
  getAliases() {
    return e((t) => t.aliases || {});
  },
  getSiteId() {
    return e(
      (t) => u[t.website?.site || "COM"]
    );
  },
  getSiteName() {
    return e((t) => t.website?.site || "COM");
  },
  getStarsDomain() {
    return n(
      (t) => a.cms.getSiteId(t),
      (t) => ({
        [u.IT]: "starsaccount.it",
        [u.GR]: "starsaccount.gr",
        [u.FR]: "starsaccount.fr",
        [u.ES]: "starsaccount.es",
        [u.DK]: "starsaccount.dk",
        [u.EU]: "starsaccount.eu",
        [u.UK]: "starsaccount.uk",
        [u.BG]: "starsaccount.bg",
        [u.DESH]: "sh.starsaccount.de",
        [u.RO]: "starsaccount.ro",
        [u.EE]: "starsaccount.ee",
        [u.CZ]: "starsaccount.cz",
        [u.BE]: "starsaccount.be",
        [u.RUSOPM]: "starsaccount.net",
        [u.PT]: "starsaccount.pt",
        [u.SE]: "starsaccount.se",
        [u.NET]: "starsaccount.net",
        [u.USPA]: "starsaccountpa.com",
        [u.USNJ]: "pokerstarscasinonj.com",
        [u.USMI]: "pokerstarscasinomi.com",
        [u.NL]: "pokerstars.nl"
      })[t] || "starsaccount.com"
    );
  },
  getToken() {
    return n(
      e,
      (t, r) => r,
      ({ website: t }, r) => t?.tokens.find(({ key: i }) => i === r)?.value
    );
  },
  getCashierHref() {
    const t = {
      [u.COM]: "",
      [u.NET]: "",
      [u.IT]: "it",
      [u.FR]: "",
      [u.EE]: "ee",
      [u.BE]: "be",
      [u.ES]: "es",
      [u.DK]: "dk",
      [u.EU]: "eu",
      [u.USNJ]: "usnj",
      [u.UK]: "uk",
      [u.BG]: "bg",
      [u.DESH]: "",
      [u.RO]: "ro",
      [u.PT]: "pt",
      [u.CZ]: "cz",
      [u.RUSO]: "",
      [u.RUSOPM]: "",
      [u.IN]: "",
      [u.ASIA]: "",
      [u.RU]: "",
      [u.USPA]: "",
      [u.SE]: "se",
      [u.CH]: "",
      [u.ARBA]: "",
      [u.USCO]: "uspa",
      [u.DE]: "",
      [u.USMI]: "uspa",
      [u.NL]: "",
      [u.CAON]: "",
      [u.GR]: ""
    };
    return n(
      (r) => a.device.isEmbedded(r),
      (r) => a.cms.getSiteId(r),
      (r, i) => r ? `pokerstars${t[i]}://cashier/open` : void 0
    );
  },
  getWebsite() {
    return e(({ website: t }) => t);
  },
  getWebsiteLanguages() {
    return n(
      (t) => a.cms.getWebsite(t),
      (t) => a.cms.getContent(t),
      (t, r) => {
        const i = t?.website_languages, s = !!i?.length && r[i[0].uid];
        return s ? s.languages.map((o) => r[o.uid].short_code) : [];
      }
    );
  },
  getWebsiteLaunchDate() {
    return e(({ website: t, content: r }) => {
      const i = t?.website_config, s = !!i?.length && r[i[0].uid];
      return s ? s.isp_launch_date : void 0;
    });
  },
  getPageMenu() {
    return e(({ menu: t }) => t);
  },
  getPageMenuDepth() {
    return e(({ depth: t }) => t);
  },
  getTouchpointConfig() {
    return e(({ website: t, content: r }) => {
      const i = t?.website_config, s = !!i?.length && r[i[0].uid];
      return s ? s.touchpoint : void 0;
    });
  },
  getMenu() {
    return n(
      (t) => a.cms.getPageMenu(t),
      (t) => a.cms.getPageMenuDepth(t),
      (t, r) => ({ menu: t, depth: r })
    );
  },
  isAuthRequired() {
    return n(
      (t) => a.location.getPathname(t),
      (t) => a.cms.getWebsite(t),
      (t, r) => r?.auth_required_paths.includes(t)
    );
  },
  isSiteUS() {
    return n(
      (t) => a.cms.getSiteId(t),
      (t) => [u.USMI, u.USNJ, u.USPA, u.USCO].includes(t)
    );
  },
  isIndefiniteExclusionAllowed() {
    return n(
      this.getSiteId,
      this.showVegasContent,
      (t, r) => [u.COM, u.EU, u.NL].includes(t) && !r
    );
  },
  isVegasBrand() {
    return n(
      (t) => a.cms.getBrandId(t),
      (t) => t === _.PokerStarsVegas
    );
  },
  getActiveAlias() {
    return n(
      (t) => a.cms.getPage(t),
      (t) => a.cms.getAliases(t),
      (t, r) => Object.keys(r).filter(
        (i) => t?.url && je(r[i] ?? "") === je(t?.url)
      )?.[0]
    );
  },
  matchAlias: () => n(
    (t) => a.cms.getUrlPathname(t),
    (t) => a.cms.getPage(t),
    (t) => a.cms.getAliases(t),
    (t) => a.cms.getActiveAlias(t),
    (t, r, i, s) => {
      const o = r?.alias || s;
      return o ? st(t, { path: i[o], exact: !0, strict: !1 }) : null;
    }
  ),
  showVegasContent() {
    return n(
      (t) => a.cms.getSiteId(t),
      (t) => a.country.getCountry(t),
      (t) => t.account?.country,
      (t, r, i) => t === u.DESH || t === u.DE || t === u.EU && (i || r) === pe.Germany
    );
  },
  showOntarioContent() {
    return n(this.getSiteId, (t) => t === u.CAON);
  },
  getRedirectUrl() {
    return n(
      (t) => a.localSettings.get(t),
      ({ redirectTo: t }) => t || "/"
    );
  },
  getUrl: () => e((t) => t.url),
  getUrlPathname: () => n(
    (t) => a.cms.getUrl(t),
    (t) => a.locale.get(t),
    (t, r) => Et(t?.pathname || "/", r)
  ),
  getUrlParams: () => n(
    (t) => a.cms.matchAlias(t),
    (t) => t ? t.params : {}
  ),
  isIspRouting: () => n(
    (t) => a.feature.check(t, g.ISPRouting),
    (t) => a.location.getQuery(t),
    (t, { siteId: r }) => t || r === "isp"
  )
}), ir = (e) => (e.page && !e.page.layout && (e.page.layout = Xn), e), sr = {
  update: (e, { content: n, url: t, ...r }) => ({
    ...e,
    redirect: void 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    geo_redirect: void 0,
    url: t,
    // TODO: CMS-migration - remove addDefaultPageLayout after stack content can be modified
    ...ir(r),
    content: { ...e.content, ...n }
  }),
  setPageLoaded: (e, n) => ({ ...e, pageLoaded: n }),
  addAliases: (e, n) => ({
    ...e,
    aliases: {
      ...e.aliases,
      ...n
    }
  })
}, or = {
  state: { content: {} },
  reducers: sr,
  effects: Fn,
  selectors: rr
}, ar = { requestTimeout: 2e4 }, cr = {
  set: (e, n = {}) => ({ ...e, ...n })
}, ur = (e) => ({
  get() {
    return e;
  }
}), dr = {
  state: ar,
  reducers: cr,
  selectors: ur
}, lr = {
  set: (e, n) => n
}, pr = (e) => ({
  get() {
    return e;
  },
  getCountry() {
    return e((n) => n.country);
  },
  getState() {
    return e((n) => n.state);
  }
}), mr = {
  state: { country: "", state: "" },
  reducers: lr,
  selectors: pr
};
var G = /* @__PURE__ */ ((e) => (e[e.CLOSED = 0] = "CLOSED", e[e.CONNECTING = 1] = "CONNECTING", e[e.CONNECTED = 2] = "CONNECTED", e[e.DISCONNECTED = 3] = "DISCONNECTED", e))(G || {});
const de = {}, ke = Be(K.Socket), Ae = Be(K.Frame), Er = (e) => {
  const n = e.substring(0, 4), { frames: t } = Ke.unmarshall(e.substring(4));
  if (!t.length) {
    ke(e);
    return;
  }
  t.forEach((r) => {
    const i = fe(r.body), s = n + Ke.marshall(r.command, r.headers).replace(/\n\n\x00$/, "");
    if (i && R)
      Ae("%s%o", s, i);
    else if (i) {
      const o = s.split(`
`);
      o.pop(), Ae(`${Tt(`%s
`, Object.keys(o).length)}%o`, ...o, i);
    } else
      Ae(s);
  });
}, Xe = (e, n, t) => {
  if (n.connected)
    return;
  t.next({ state: G.CONNECTING, client: n, config: e });
  let r;
  n.connect(
    { ...e.getHeaders() },
    (i) => {
      r = setTimeout(() => n.reconnect_delay = 0, 5e3), t.next({ state: G.CONNECTED, client: n, config: e });
    },
    (i) => null,
    ({ reason: i }) => {
      clearTimeout(r), n.reconnect_delay = e.getReconnect(n.reconnect_delay, i), n.headers = _e(n.headers, e.getHeaders()), t.next({ config: e, state: G.DISCONNECTED, client: n, disconnectReason: i }), ke("Lost connection from server: %s", i);
    }
  );
}, Ze = (e, n, t) => n.disconnect(() => {
  ke("Disconnected from server"), t.next({ config: e, state: G.CLOSED, client: n });
}), _r = (e) => new ot((n) => {
  const t = Wt(() => new Ft(e.url, null, e.sockJSOptions));
  return t.debug = Er, R && (document.addEventListener("starspause", () => Ze(e, t, n)), document.addEventListener("starsresume", () => Xe(e, t, n))), Xe(e, t, n), () => {
    Ze(e, t, n), delete de[e.url];
  };
}), fr = (e) => (de[e.url] || (de[e.url] = _r(e).pipe(
  $t({ config: e, state: G.DISCONNECTED }),
  Yt({ bufferSize: 1, refCount: !0 })
)), de[e.url]), ae = {}, hr = (e, n, t) => new ot((r) => {
  const i = e.subscribe(
    n,
    (s) => r.next({
      headers: s.headers,
      body: fe(s.body)
    }),
    Mt(t, (s, o) => o.toLowerCase())
  );
  return () => e.connected && !!e.subscriptions?.[i.id] && i.unsubscribe();
}), It = (e, n, t) => (ae[e] || (ae[e] = t.pipe(
  at(({ state: r }) => r === G.CONNECTED),
  ct(({ client: r }) => hr(r, e, n)),
  Qt(() => delete ae[e]),
  jt()
)), ae[e]);
var re = /* @__PURE__ */ ((e) => (e.ACCOUNT_CLOSED = "ACCOUNT_CLOSED", e.ACCOUNT_CLOSED_PV = "ACCOUNT_CLOSED_PV", e.APC_ON_DIFF_DEVICE = "APC_ON_DIFF_DEVICE", e.BANNED_BY_REGULATOR = "BANNED_BY_REGULATOR", e.BLOCKED_BY_GEO_IP = "BLOCKED_BY_GEO_IP", e.CLIENT_TIMEOUT = "CLIENT_TIMEOUT", e.CONNECTION_CLOSED = "CONNECTION_CLOSED", e.EMAIL_NOT_ALLOWED = "EMAIL_NOT_ALLOWED", e.ERR_COUNTRY_RESTRICTED = "ERR_COUNTRY_RESTRICTED", e.ERR_LUGAS_REQUEST_FAILED = "ERR_LUGAS_REQUEST_FAILED", e.ERR_USER_OWES_CHIPS = "ERR_USER_OWES_CHIPS", e.INVALID_CREDENTIALS = "INVALID_CREDENTIALS", e.LICENSE_MISMATCH = "LICENSE_MISMATCH", e.LOGIN_COOL_OFF = "LOGIN_COOL_OFF", e.LOGIN_MSG_NOT_ALLOWED = "LOGIN_MSG_NOT_ALLOWED", e.MITID_AUTH_REQUIRED = "MITID_AUTH_REQUIRED", e.NEMID_LOGIN_REQUIRED = "NEMID_LOGIN_REQUIRED", e.NOT_ALLOWED_USER_ACTIVE = "NOT_ALLOWED_USER_ACTIVE", e.NO_SUCH_USER = "NO_SUCH_USER", e.PANIC_BUTTON_EXCLUDED = "PANIC_BUTTON_EXCLUDED", e.PERMANENTLY_EXCLUDED = "PERMANENTLY_EXCLUDED", e.PIN_INVALID = "PIN_INVALID", e.PIN_REQUIRED = "PIN_REQUIRED", e.POW_REQUIRED = "POW_REQUIRED", e.PREVENT_LOGIN = "PREVENT_LOGIN", e.RSA_INVALID_CREDENTIALS = "RSA_INVALID_CREDENTIALS", e.RSA_REQUIRED = "RSA_REQUIRED", e.SELF_EXCLUDED = "SELF_EXCLUDED", e.SESSION_COOL_OFF = "SESSION_COOL_OFF", e.SITE_MISMATCH = "SITE_MISMATCH", e.TEMP_PIN_REQUIRED = "TEMP_PIN_REQUIRED", e.TEMP_PIN_REQUIRED_SMS = "TEMP_PIN_REQUIRED_SMS", e.TIME_LIMIT_REACHED = "TIME_LIMIT_REACHED", e.TOTAL_LIMIT_REACHED = "TOTAL_LIMIT_REACHED", e.TRANSFER_APC_NOT_READY = "TRANSFER_APC_NOT_READY", e.UNKOWN_ERROR = "UNKOWN_ERROR", e.USER_BANNED_BY_REGULATOR = "USER_BANNED_BY_REGULATOR", e.USER_HAS_PENDING_CASHOUTS = "USER_HAS_PENDING_CASHOUTS", e.USER_SELF_EXCUDED = "USER_SELF_EXCLUDED", e.VALIDATION_ERROR = "VALIDATION_ERROR", e))(re || {}), me = /* @__PURE__ */ ((e) => (e[e.OK = 0] = "OK", e.ACCOUNT_CLOSED = "accountClosed", e.ACCOUNT_CLOSED_PV = "accountClosedPv", e.ACCOUNT_REVALIDATION_REQUIRED = "forceReAuthentication", e.APC_ON_DIFF_DEVICE = "APCOnDiffDevice", e.ARCHIVED = "archived", e.BAD_FORMAT = "BAD_FORMAT", e.BIRTHDAY_INVALID = "birthdayInvalid", e.BIRTHDAY_REQUIRED = "birthdayRequired", e.BLOCKED_BANNED_BY_REGULATOR = "bannedByRegulator", e.BLOCKED_REVAL_REQD = "loginBlockedRevalidationRequired", e.BLOCKED_BLACKLISTED = "BLOCKED_BLACKLISTED", e.EMAIL_NOT_ALLOWED = "emailLoginError", e.ERR_VIPSTORE_UNIQUE_ROLL_USED = "ERR_VIPSTORE_UNIQUE_ROLL_USED", e.ERROR_TYPO = "typo", e.FORBIDDEN = "FORBIDDEN", e.INTERNAL = "INTERNAL", e.LICENSE_MISMATCH = "licenseMismatch", e.LOGIN_ALREADY_LOGGEDIN = "alreadyLoggedin", e.LOGIN_BLOCKED_BY_GEO_IP = "blockedByGeoIp", e.LOGIN_CASHIER_CLOSED = "cashierIsClosed", e.LOGIN_COOL_OFF = "loginCoolOffLimit", e.LOGIN_EXPLICIT_LOGIN_DK_REQUIRED = "explicitLoginDKRequired", e.LOGIN_INTERNAL = "internalError", e.LOGIN_INVALID_CREDENTIALS = "invalidCredentials", e.LOGIN_LIMIT_REACHED = "limitReached", e.LOGIN_NOT_ALLOWED = "notAllowed", e.LOGIN_NOT_EMAIL_VERIFIED = "notEmailVerified", e.LOGIN_NOT_REALMONEYOK = "notRealMoneyOk", e.LOGIN_SELF_EXCLUDED = "selfExcluded", e.LOGIN_STRONG_AUTH_REQUIRED = "strongAuthRequired", e.LOGIN_TIME_LIMIT_REACHED = "timeLimitReached", e.LOGIN_TOTAL_LIMIT_REACHED = "totalLimitReached", e.LONG_SESSION_COOL_OFF = "longSessionCoolOff", e.MITID_AUTH_REQUIRED = "mitIdAuthRequired", e.MITID_AUTH_FAILED = "mitIdAuthFailed", e.TRANSFER_APC_NOT_READY = "transferAPCNotReady", e.NOT_ENOUGH_FPP = "NOT_ENOUGH_FPP", e.NOT_FOUND = "NOT_FOUND", e.PANIC_BUTTON_EXCLUDED = "panicButtonExcluded", e.PIN_INVALID = "pinInvalid", e.PIN_REQUIRED = "pin", e.POW_REQUIRED = "POW", e.POW_INVALID = "pow.challengeResult.invalid", e.PREVENT_LOGIN = "preventLogin", e.RSA_INVALID_CREDENTIALS = "rsaInvalidCredentials", e.RSA_NOT_ALLOWED = "RSAnotAllowed", e.RSA_REQUIRED = "rsa", e.RSA_TOKEN_DISABLED = "rsaTokenDisabled", e.SITE_MISMATCH = "siteMismatch", e.SMS_VALIDATION_REQUIRED = "smsValidationRequired", e.TEMP_PIN_REQUIRED = "temppin", e.TEMP_PIN_REQUIRED_SMS = "temppinsms", e.TIMEOUT = "TIMEOUT", e.TMP_PWD_EXPIRED = "tempPwdExpired", e.UNAUTHORIZED = "UNAUTHORIZED", e.UNKNOWN = "UNKNOWN", e.USER_EULA_REQUIRED = "EULA", e.USER_IN_LIMITED_MODE = "userInLimitedMode", e.VALIDATION_ERROR = "VALIDATION_ERROR", e[e.SYSTEM_ERROR = 1] = "SYSTEM_ERROR", e[e.INPUT_ERROR = 2] = "INPUT_ERROR", e[e.BUSY_ERROR = 3] = "BUSY_ERROR", e[e.SHUTDOWN_ERROR = 4] = "SHUTDOWN_ERROR", e[e.AUTH_ERROR = 5] = "AUTH_ERROR", e[e.NO_SESSION_ERROR = 6] = "NO_SESSION_ERROR", e[e.OBSOLETE_ERROR = 7] = "OBSOLETE_ERROR", e[e.SESSION_AUTH_ERROR = 8] = "SESSION_AUTH_ERROR", e[e.SESSION_CLOSED_ERROR = 9] = "SESSION_CLOSED_ERROR", e[e.TIMEOUT_ERROR = 10] = "TIMEOUT_ERROR", e[e.ALREADY_PLAYING_ERROR = 11] = "ALREADY_PLAYING_ERROR", e[e.INTERRUPTED_GAME_ERROR = 12] = "INTERRUPTED_GAME_ERROR", e[e.GAME_UNAVAILABLE = 13] = "GAME_UNAVAILABLE", e[e.SLOT_LIMIT_EXCEEDED = 14] = "SLOT_LIMIT_EXCEEDED", e[e.CONCURRENT_LOGIN = 15] = "CONCURRENT_LOGIN", e[e.REQUEST_NOT_FOUND = 16] = "REQUEST_NOT_FOUND", e[e.INVALID_EMAIL = 17] = "INVALID_EMAIL", e[e.HAND_HISTORY_ERROR = 18] = "HAND_HISTORY_ERROR", e[e.MULTI_PLATFORM_LOGIN = 19] = "MULTI_PLATFORM_LOGIN", e[e.NO_COUNTRY = 20] = "NO_COUNTRY", e[e.NOT_ALLOWED = 21] = "NOT_ALLOWED", e[e.UNFINISHED_GAMES_ON_ANOTHER_DEVICE = 22] = "UNFINISHED_GAMES_ON_ANOTHER_DEVICE", e[e.FSB_ALREADY_IN_PROGRESS = 23] = "FSB_ALREADY_IN_PROGRESS", e[e.IGT_INTERRUPTED_GAME_ERROR = 24] = "IGT_INTERRUPTED_GAME_ERROR", e[e.RACE_ALREADY_PLAYING_ERROR = 27] = "RACE_ALREADY_PLAYING_ERROR", e[e.NO_TOURNAMENTS = 31] = "NO_TOURNAMENTS", e[e.RACE_FINISHED = 33] = "RACE_FINISHED", e[e.DUPLICATE_NEW_USER_EMAIL = 35] = "DUPLICATE_NEW_USER_EMAIL", e[e.RACE_ONLY_ONE_AT_A_TIME = 39] = "RACE_ONLY_ONE_AT_A_TIME", e[e.RACE_PROMO_BAN = 44] = "RACE_PROMO_BAN", e[e.RACE_BLOCKED_IN_COUNTRY = 45] = "RACE_BLOCKED_IN_COUNTRY", e[e.BALANCE_PENDING_BONUS_ERROR = 56] = "BALANCE_PENDING_BONUS_ERROR", e[e.SUCCESSFUL_DEPOSIT_LIMIT = 65] = "SUCCESSFUL_DEPOSIT_LIMIT", e[e.DEPOSIT_LIMIT_ALREADY_REQUESTED = 73] = "DEPOSIT_LIMIT_ALREADY_REQUESTED", e[e.DEPOSIT_LIMIT_REQUEST_PROCESSING = 80] = "DEPOSIT_LIMIT_REQUEST_PROCESSING", e[e.DEPOSIT_LIMIT_INCREASE_DENIED = 82] = "DEPOSIT_LIMIT_INCREASE_DENIED", e[e.HAND_NOT_FOUND = 95] = "HAND_NOT_FOUND", e[e.WRONG_PWD = 100] = "WRONG_PWD", e[e.ALREADY_SELF_EXCLUDED_ERROR = 147] = "ALREADY_SELF_EXCLUDED_ERROR", e[e.USER_SELF_EXCLUDED = 148] = "USER_SELF_EXCLUDED", e[e.ALREADY_BANNED = 158] = "ALREADY_BANNED", e[e.EMAIL_ALREADY_EXISTS = 170] = "EMAIL_ALREADY_EXISTS", e[e.ALREADY_REQUESTED = 174] = "ALREADY_REQUESTED", e[e.INVALID_PHONE = 172] = "INVALID_PHONE", e[e.SERVICE_NOT_AVAILABLE = 204] = "SERVICE_NOT_AVAILABLE", e[e.BALANCE_PENDING_TRANSACTION_ERROR = 211] = "BALANCE_PENDING_TRANSACTION_ERROR", e[e.BALANCE_NOT_EMPTY_ERROR = 236] = "BALANCE_NOT_EMPTY_ERROR", e[e.CLIENT_NOT_AVAILABLE_FOR_COUNTRY = 258] = "CLIENT_NOT_AVAILABLE_FOR_COUNTRY", e[e.ERR_COUNTRY_RESTRICTED = 269] = "ERR_COUNTRY_RESTRICTED", e[e.UNVALIDATED_EMAIL = 293] = "UNVALIDATED_EMAIL", e[e.STAR_CODE_INVALID = 392] = "STAR_CODE_INVALID", e[e.STAR_CODE_MAX_NUMBER_OF_PLAYERS_ALREADY_USED = 394] = "STAR_CODE_MAX_NUMBER_OF_PLAYERS_ALREADY_USED", e[e.STAR_CODE_ALREADY_SUBMITTED = 395] = "STAR_CODE_ALREADY_SUBMITTED", e[e.STAR_CODE_INVALID_DATE = 396] = "STAR_CODE_INVALID_DATE", e[e.USER_BANNED_BY_REGULATOR = 421] = "USER_BANNED_BY_REGULATOR", e[e.ERR_DUPLICATE_REQUEST = 480] = "ERR_DUPLICATE_REQUEST", e[e.STAR_CODE_CANNOT_BE_USED = 483] = "STAR_CODE_CANNOT_BE_USED", e[e.COOLING_PERIOD_IN_EFFECT = 512] = "COOLING_PERIOD_IN_EFFECT", e[e.ERR_TRY_AGAIN = 539] = "ERR_TRY_AGAIN", e[e.REGISTRATION_BLOCKED_BY_GEO_IP = 754] = "REGISTRATION_BLOCKED_BY_GEO_IP", e[e.SECURITY_CODE_VALIDATION_FAILED = 758] = "SECURITY_CODE_VALIDATION_FAILED", e[e.INCREASE_LIMIT_NOT_ALLOWED = 796] = "INCREASE_LIMIT_NOT_ALLOWED", e[e.SELFEXCLUSION_INVALID_VALUE = 821] = "SELFEXCLUSION_INVALID_VALUE", e[e.LUGAS_REQUEST_FAILED = 849] = "LUGAS_REQUEST_FAILED", e[e.LUGAS_PLAYER_IS_INACTIVE = 851] = "LUGAS_PLAYER_IS_INACTIVE", e[e.SMS_VALIDATION_ENABLED = 1002] = "SMS_VALIDATION_ENABLED", e))(me || {});
const Sr = Me(me), Ir = (e) => !!e?.code;
class k extends Error {
  constructor({
    service: n,
    body: t,
    response: r,
    method: i,
    headers: s,
    requestId: o
  }) {
    const c = r?.status, d = c && c >= 400 ? c : i;
    let l;
    if (Ir(t))
      l = { ...t };
    else if (s?.["status-code"]) {
      const { ["status-code"]: m } = s;
      l = { code: Sr[m] || it(m).toUpperCase(), text: "" };
    } else
      l = { code: re.UNKOWN_ERROR, text: "" };
    super(`${d} ${n} ${l.code}`), this.statusCode = 500, Object.setPrototypeOf(this, k.prototype), Ue.addBreadcrumb({
      type: "debug",
      category: "request-error",
      message: this.message,
      data: { method: i, service: n, statusCode: r?.status }
    }), this.name = "RequestError", this.body = l, this.response = r, this.service = n, this.requestId = o, this.headers = s || r?.headers, this.statusCode = c || 500;
  }
  log() {
    te(K.Request, this.requestId)("failed %s %s", this.service, this.message.replace(` ${this.service}`, "")), process.env.NODE_ENV !== "test" && (!this.response || this.response.ok) && R && console.error(this.message);
  }
}
var Ee = /* @__PURE__ */ ((e) => (e.BadFormat = "BF", e.BadSignature = "BS", e.InvalidMessageType = "MT", e.InvalidSessionId = "IS", e.InvalidSubscriptionDestination = "ID", e.InvalidToken = "IT", e.MaxSubscriptionExceeded = "MS", e.TokenRequired = "TR", e.UnknownOrigin = "UO", e.UserChangeNotAllowed = "UC", e.VelocityControl = "VC", e))(Ee || {});
function Fe({
  retry: e,
  service: n,
  method: t,
  requestId: r
}) {
  const i = e.delay ?? function(s) {
    return Math.pow(2, s) * 1e3;
  };
  return (s) => s.pipe(
    zt(
      (o) => o.pipe(
        Jt((c, d) => ({ count: c.count + 1, error: d }), {
          count: 0,
          error: void 0
        }),
        Oe(({ count: c, error: d }) => {
          if (c > e.count)
            throw d.name === "TimeoutError" ? new k({
              service: n,
              method: t,
              body: { code: re.CLIENT_TIMEOUT, text: "Request timed out" },
              requestId: r
            }) : d;
        }),
        Xt((c) => xt(i(c.count)))
      )
    )
  );
}
const At = ({ challenge: e, difficulty: n, id: t, maxTries: r, script: i }) => {
  const s = {
    challengeResult: 0,
    challengeResult2: 0
  }, o = new Function(i + "return proofOfWork")();
  return window.jsSHA = en, s.challengeResult = o(e, n, r), delete window.jsSHA, s.challengeResult instanceof Array && ([s.challengeResult, s.challengeResult2] = s.challengeResult), JSON.stringify({ challenge: e, id: t, ...s });
}, Ar = /^\/api\/v(\d)/, et = (e) => it(e).toUpperCase();
let De, Rr = 0;
process.env.NEXT_RUNTIME === "nodejs" && (De = global.__PS_REQUEST_HISTOGRAM || new (require("prom-client")).Histogram({
  help: "API request duration in milliseconds.",
  name: "api_requests",
  buckets: [50, 100, 200, 300, 400, 500, 1e3, 2e3],
  labelNames: ["service"]
}), global.__PS_REQUEST_HISTOGRAM = De);
const we = (e, n, t, r) => {
  const i = te(K.Request, r), s = te(K.RequestInfo, r), o = Date.now() - e;
  i("success %s [%dms]", n, o), s("success %s %o", n, t), process.env.CLIENT_FRAMEWORK !== "NEXTJS" && De?.observe({ service: n }, o);
}, Rt = (e, n, t, r) => {
  const i = n.headers["x-request-id"];
  return fetch(e, n).catch((s) => {
    throw new k({
      service: t,
      method: n.method,
      body: { code: et(s.name), text: s.message },
      requestId: i
    });
  }).then(async (s) => {
    const o = await s.text();
    let c;
    try {
      o && (c = JSON.parse(o));
    } catch (d) {
      const { type: l, name: m, message: p } = d;
      throw new k({
        service: t,
        method: n.method,
        body: { code: et(l || m), text: p },
        response: s,
        requestId: i
      });
    }
    if (s.ok)
      return we(r, t, c, i), { headers: Object.fromEntries(s.headers.entries()), body: c };
    if (c?.code === re.POW_REQUIRED && !n.headers["pow-result"])
      return n.headers["pow-result"] = At(c.challenge), Rt(e, n, t, r);
    throw new k({ service: t, body: c, response: s, method: n.method, requestId: i });
  });
};
async function Or({
  service: e,
  body: n,
  method: t = "GET",
  connection: r,
  http: i,
  httpDomain: s,
  timeout: o,
  silent: c,
  signal: d,
  retry: l = { count: 0 },
  ...m
}) {
  const p = m.headers || {}, E = p["x-request-id"], N = te(K.Request, E), D = Rr++, C = Date.now(), v = JSON.stringify(n), [, A = 0] = e.match(Ar)?.map((S) => parseInt(S)) || [];
  if (n ? N("start %s %o", e, n) : N("start %s", e), p.accept = p.accept || "application/json", i) {
    const S = new W(e, s);
    let I;
    if (R && delete p.referer, ["GET", "HEAD"].includes(t) && Pn(n)) {
      let b = "";
      Object.entries(n).forEach(([B, $]) => {
        const Y = typeof $ != "string" ? JSON.stringify($) : $;
        b.length && (b += "&"), b += B + "=" + Y;
      }), S.set("query", b), I = void 0;
    } else
      p["content-type"] = "application/json", I = v;
    return (n instanceof URLSearchParams || n instanceof FormData) && t === "POST" && (delete p["content-type"], I = n), $e(
      qt(
        () => Rt(
          S.toString(),
          { method: t, headers: p, body: I, signal: d, credentials: "include" },
          e,
          C
        )
      ).pipe(Fe({ retry: l, method: t, service: e, requestId: E }))
    );
  }
  if (p["message-id"] = D.toString(), p["content-type"] = "application/json", A === 0)
    p.type = e;
  else {
    const [, , , ...S] = e.split("/");
    p.destination = `/${S.join("/")}`, p["x-sw-version"] = A.toString(), p.method = t;
  }
  return $e(
    r.pipe(
      Oe(({ client: S, state: I, config: b, disconnectReason: B }) => {
        switch (!0) {
          case B === Ee.InvalidToken:
            delete p.token, delete p.signature, delete p.authorization;
            break;
          case I === G.CLOSED:
            throw new k({
              service: e,
              method: t,
              body: {
                code: re.CONNECTION_CLOSED,
                text: "The connection was closed before a response was received."
              },
              requestId: E
            });
          case I === G.CONNECTED:
            S?.send(p.destination || b.requestDestination, p, v);
            break;
        }
      }),
      at(({ state: S }) => S === G.CONNECTED),
      ct(({ client: S, config: I }) => {
        const { requestDestination: b, requestTimeout: B } = I, $ = o || B, Y = A > 0 ? "/user/queue/response" : I.responseChannel;
        return It(Y, {}, r).pipe(
          Ye(({ headers: ie, body: Z }) => {
            const { "status-code": Ge, "reply-id": Pt } = ie;
            if (parseInt(Pt) !== D)
              return !1;
            if (A > 0) {
              const ve = parseInt(Ge), Dt = R ? window.Blob : require("buffer").Blob;
              if (ve >= 400)
                throw new k({
                  service: e,
                  body: Z,
                  response: new Response(new Dt(), { status: ve }),
                  method: t,
                  requestId: E
                });
              return we(C, e, Z, E), !0;
            }
            switch (fe(Ge)) {
              case me.POW_REQUIRED:
                return ie["pow-result"] = At(Z), S?.send(b, ie, v), !1;
              case me.OK:
                return we(C, e, Z, E), !0;
              default:
                throw new k({ headers: ie, body: Z, service: e, method: t, requestId: E });
            }
          }),
          Zt($)
        );
      }),
      Fe({ retry: l, method: t, service: e, requestId: E }),
      Oe({
        error: (S) => {
          c || (S instanceof k ? S.log() : console.error(S));
        }
      }),
      Ye()
    )
  );
}
te(K.Embedded);
const gr = (e) => R && q(window, ["starsweb", ...e]), Nr = (e, ...n) => R && q(window, ["starsweb", ...e], () => {
})(...n), tt = {
  CAON: P.CanadianDollar,
  ES: P.Euro,
  EU: P.Euro,
  FR: P.Euro,
  IN: P.IndianRupee,
  IT: P.Euro,
  PT: P.Euro,
  RO: P.RomanianLeu,
  RU: P.RussianRuble,
  SE: P.SwedishKrona,
  UK: P.BritishPound
}, be = new ft(), Pr = {
  set: (e, { selected: n }) => ({
    ...e,
    selected: n
  }),
  setSelfLimitCurrency: (e, { selfLimitCurrency: n }) => ({
    ...e,
    selfLimitCurrency: n
  }),
  setUserLimits: (e, { userLimits: n }) => ({
    ...e,
    userLimits: n
  })
}, Dr = {
  async setPlayMoney({ selected: e }, { dispatch: n, rootState: t, select: r }) {
    r.device.isEmbedded(t) ? Nr(["app", "setPlayMoney"], e) : (n.currency.set({ selected: e ? P.PlayMoney : void 0 }), e ? be.set(z.CURRENCY, P.PlayMoney) : be.remove(z.CURRENCY));
  }
}, wr = (e, n) => ({
  get() {
    return n(
      e,
      (t) => a.account.getCurrency(t),
      (t) => a.cms.getSiteName(t),
      ({ selected: t }, r, i) => t || r || tt[i] || P.USDollar
    );
  },
  getRealMoney() {
    return n(
      (t) => a.account.getCurrency(t),
      (t) => a.cms.getSiteName(t),
      (t, r) => t || tt[r] || P.USDollar
    );
  },
  getUserLimits() {
    return e((t) => t.userLimits);
  },
  isPlayMoney() {
    return e((t) => t.selected === P.PlayMoney);
  },
  getPlayMode() {
    return e((t) => t.selected === P.PlayMoney ? "PM" : "RM");
  },
  getSelfLimitCurrency() {
    return n(
      e,
      (t) => a.currency.getRealMoney(t),
      ({ selfLimitCurrency: t }, r) => t || r
    );
  }
}), br = {
  state: {
    selected: gr(["app", "playMoney"]) || be.get(z.CURRENCY) || null
  },
  reducers: Pr,
  effects: Dr,
  selectors: wr
}, Lr = {
  update: (e, n) => ({ ...e, ...n })
}, yr = (e, n) => ({
  get() {
    return e;
  },
  getId() {
    return e(({ device: t }) => t);
  },
  getName() {
    return e(({ device: t }) => V[t]);
  },
  isMobile() {
    return e(({ device: t }) => [V.PHONE, V.TABLET].includes(t));
  },
  isPhone() {
    return e(({ device: t }) => t === V.PHONE);
  },
  isAndroid() {
    return e(({ os: t }) => t === Q.ANDRO_ID);
  },
  getOS() {
    return e(({ os: t }) => t);
  },
  getOSName() {
    return e((t) => Me(Q)[t.os]);
  },
  isDesktopEmbedded() {
    return e(
      ({ embedded: t, device: r }) => [V.DESKTOP, V.OTHER].includes(r) && t
    );
  },
  isMobileEmbedded() {
    return e(
      ({ embedded: t, device: r }) => [V.PHONE, V.TABLET].includes(r) && t
    );
  },
  isEmbedded() {
    return e(({ embedded: t }) => t);
  },
  getPlatform() {
    return e(({ embedded: t, os: r }) => {
      switch (!0) {
        case (t && r === Q.WINDOWS):
          return F.WIN;
        case (t && r === Q.MAC):
          return F.MAC;
        case (t && r === Q.ANDRO_ID):
          return F.ANDROID;
        case (t && r === Q.I_OS):
          return F.I_OS;
        default:
          return F.WEB;
      }
    });
  }
}), Cr = {
  state: { device: V.UNKNOWN, os: Q.UNKNOWN, embedded: !1 },
  reducers: Lr,
  selectors: yr
}, Tr = {
  async check(e, { dispatch: n, request: t }) {
    const { body: r } = await t({
      service: "features.check",
      body: { features: Object.values(g) }
    });
    n.feature.update(r);
  }
}, Mr = (e, n) => ({
  get() {
    return e;
  },
  check() {
    return n(
      e,
      (t, r) => r,
      (t, r) => !!t[r]
    );
  },
  list() {
    return e((t) => Object.keys(t));
  }
}), Le = R && fe(localStorage.getItem("starsweb-features")), Br = {
  "persist/REHYDRATE": (e) => ({ ...e, ...Le }),
  update: (e, n) => ({ ...e, ...n, ...Le })
}, Ur = {
  state: Le || {},
  reducers: Br,
  effects: Tr,
  selectors: Mr
}, kr = {
  documentsSubmitted: !1,
  layoutMode: lt.Table,
  showBalance: !0,
  homegames: { gameTileView: {} },
  poker: {
    spinAndGo: {
      onboardingFinished: !1,
      onboardingModalShown: !1
    }
  },
  cashierTour: {
    onboardingFinished: !1,
    onboardingModalShown: !1,
    lastModalShown: !1
  }
}, Gr = {
  "persist/REHYDRATE": (e, { localSettings: n } = {}) => ({
    ...e,
    ...n
  }),
  set: (e, n = {}) => _e({}, e, n)
}, vr = (e) => ({
  get() {
    return e((n) => n || {});
  },
  getRegistrationBrand() {
    return e((n) => n.registrationBrand);
  }
}), Vr = {
  state: kr,
  reducers: Gr,
  selectors: vr
}, Hr = {
  set: (e, n) => n || e
}, Wr = (e, n) => ({
  get() {
    return e;
  },
  getIntlLocale() {
    return n(
      e,
      (t) => a.country.getCountry(t),
      (t) => a.account.getCountry(t),
      (t, r, i) => {
        const s = i || r;
        try {
          const [o] = tn(`${t}-${s}`);
          return o;
        } catch {
          return t;
        }
      }
    );
  }
}), xr = {
  state: "en",
  reducers: Hr,
  selectors: Wr
}, ye = (e) => {
  const { auth: n, password: t, username: r, slashes: i, ...s } = typeof e == "string" ? new W(e, !0) : e;
  return s;
}, qr = {
  "cms/update": (e, { url: n }) => n ? ye(n) : { ...e },
  update: (e, n) => ye(n)
}, Kr = (e, n) => ({
  get() {
    return e;
  },
  getHost() {
    return e((t) => t.host);
  },
  getHostname() {
    return e((t) => t.hostname);
  },
  getQuery() {
    return e((t) => t.query);
  },
  getPort() {
    return e((t) => t.port);
  },
  getProtocol() {
    return e((t) => t.protocol);
  },
  getRedirectPath() {
    return n(
      e,
      (t) => a.locale.get(t),
      (t, r) => {
        const i = new W(t.href, !0);
        if (i.query.modal)
          return i.set("host", ""), i.set("protocol", ""), i.set("slashes", !1), delete i.query.mitid, delete i.query.modal, i.toString().replace(new RegExp(`^/${r}(/.*)?$`), "$1");
      }
    );
  },
  getOrigin() {
    return e((t) => t.origin);
  },
  getPathname() {
    return e((t) => t.pathname);
  },
  getHref() {
    return e((t) => t.href);
  },
  getCookieDomain() {
    return e(
      (t) => wn ? "localhost" : t.hostname.split(".").slice(1).join(".")
    );
  },
  getWC2Domain() {
    return n(
      e,
      this.getCookieDomain,
      this.getPort,
      (t, r, i) => new W("").set("protocol", "https").set("hostname", `cashier.${r}`).set("port", i).href
    );
  },
  getAnalyticsPath() {
    return n(
      e,
      this.stripPrefix,
      (t) => a.modal.getCurrent(t),
      (t, r, i) => {
        if (i)
          return "/modal" + i.path;
        if (!st(r, { path: "/(signup|deposit|withdraw)" }))
          return `${t.pathname}${t.hash}`;
      }
    );
  },
  stripPrefix() {
    return n(
      (t) => a.location.getPathname(t),
      // https://github.com/rematch/rematch/issues/966
      // Rematch reselect doesn't infer args properly
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (t, r) => r,
      (t) => a.locale.get(t),
      (t, r, i) => Dn(r || t, i)
    );
  },
  getLocaleURL() {
    return n(
      e,
      (t) => a.feature.check(t, g.ForceDefaultLocale),
      (t) => a.locale.get(t),
      ({ pathname: t }, r, i) => new RegExp(`^/${i}(/.*)?$`).test(t) || r ? `/${i}` : ""
    );
  },
  isEmbeddedRoute() {
    return n(this.stripPrefix, (t) => t.startsWith("/embedded/"));
  },
  isEmbeddedModal() {
    return n(this.stripPrefix, (t) => t.startsWith("/embedded/modal/"));
  },
  isEmbeddedPRHubModal() {
    return n(
      this.stripPrefix,
      (t) => t.startsWith("/embedded/modal/prhub/")
    );
  },
  isEmbeddedAccount() {
    return n(
      this.stripPrefix,
      (t) => t.startsWith("/embedded/account/")
    );
  },
  isEmbeddedCookieConsent() {
    return n(
      this.stripPrefix,
      (t) => t.startsWith("/embedded/cookie-consent/")
    );
  },
  getBaseURL() {
    return n(
      this.getLocaleURL,
      (t) => a.location.getPathname(t),
      (t) => a.locale.get(t),
      (t, r, i) => `${t}${mt(r, i)}` || void 0
    );
  },
  stripBaseURL() {
    return n(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (t, r) => r,
      (t) => a.location.getPathname(t),
      (t) => a.locale.get(t),
      (t, r, i) => Et(t ?? r, i)
    );
  }
}), $r = R ? ye(window.location.href) : { query: {} }, Yr = {
  state: $r,
  reducers: qr,
  selectors: Kr
}, Qr = {
  enqueue: (e, n) => [
    ...e,
    ...Ve(n) ? n : [n]
  ],
  unshift: (e, n) => Ve(n) ? [...n, ...e] : [n, ...e],
  unique: (e, n) => e.find(({ path: t }) => t === n.path) ? e : [...e, n],
  unshiftUnique: (e, n) => e.find(({ path: t }) => t === n.path) ? e : [n, ...e],
  replace: (e, n) => [...n, ...e.slice(1)],
  close: (e, n) => e.length && (!n || e[0].path.startsWith(n)) ? e.slice(1) : e,
  clear: () => []
}, jr = (e) => ({
  getCurrent() {
    return e((n) => n[0]);
  }
}), zr = {
  state: [],
  reducers: Qr,
  selectors: jr
}, Jr = {
  [f.AddressChangeSupport]: h.CUSTOMER_SUPPORT,
  [f.BonusesReleaseAndInstant]: h.RATIONAL_WEB_SERVICES,
  [f.Cashbonus]: h.RATIONAL_WEB_SERVICES,
  [f.ContactSupport]: h.CUSTOMER_SUPPORT,
  [f.FreeSpinBonus]: h.RATIONAL_WEB_SERVICES,
  [f.FreemiumBuyPlayChips]: h.FREEMIUM,
  [f.GeoAssist]: h.CUSTOMER_SUPPORT,
  [f.IceHome]: h.ICE,
  [f.Ice2Home]: h.ICE,
  [f.IceLeaderboards]: h.RATIONAL_WEB_SERVICES,
  [f.InstantBonus]: h.RATIONAL_WEB_SERVICES,
  [f.ISPFreeBets]: h.RATIONAL_WEB_SERVICES,
  [f.LiveChatSupport]: h.CUSTOMER_SUPPORT,
  [f.MinigameTicket]: h.RATIONAL_WEB_SERVICES,
  [f.PlayTheDeal]: h.WEB_ACCOUNT_SERVICE,
  [f.VerifyMeAML]: h.CUSTOMER_SUPPORT,
  [f.WebRealMoneyForm]: h.CASHIER,
  [f.BonusWheelGame]: h.WEB_ACCOUNT_SERVICE,
  [f.MatchDayMillions]: h.WEB_ACCOUNT_SERVICE,
  [f.MCVipStore]: h.VIP_STORE,
  [f.OpenBankidValidation]: h.CASHIER,
  [f.PickObjectGame]: h.WEB_ACCOUNT_SERVICE,
  [f.PMCPaywall]: h.FREEMIUM,
  [f.RGQuestion]: h.CUSTOMER_SUPPORT,
  [f.SingleReelGame]: h.WEB_ACCOUNT_SERVICE,
  [f.WC2FEBalance]: h.CASHIER,
  [f.Withdrawal]: h.CASHIER,
  [f.WC2FEConvertCurrencies]: h.CASHIER,
  [f.WC2FEDeposit]: h.CASHIER,
  [f.WC2FEHistory]: h.CASHIER,
  [f.WC2FEHome]: h.CASHIER,
  [f.WC2FEPlayMoney]: h.CASHIER,
  [f.WC2FEPreferredCurrency]: h.CASHIER
}, Xr = {
  response: (e, n) => ({ ...e, ...n })
}, Zr = {
  async fetchTag({ tokenType: e, tag: n, query: t = {}, site: r }, { dispatch: i, request: s, rootState: o }) {
    const c = a.cms.getBrandId(o).toString();
    try {
      const { body: d } = await s({
        service: "tags.resolve",
        headers: He({ brand: c, site: r }, We),
        body: He(
          {
            tag: n,
            tokenType: e === void 0 ? Jr[n] : e,
            urlParam: W.qs.stringify(t)
          },
          We
        )
      }), l = new W(
        d.url.startsWith("external-") ? d.url.substring(9) : d.url,
        !0
      );
      d.parameters && (d.parameters = Bt(d.parameters, (m) => encodeURIComponent(m))), l.set("query", { ...t, ...d.parameters, ...l.query }), i.resolver.response({ [n]: { url: l.toString(), ...d.parameters } });
    } catch (d) {
      Ue.captureException(d);
    }
  }
}, Fr = (e, n) => ({
  get() {
    return e;
  },
  getTag() {
    return n(
      e,
      (t, r) => r,
      (t, r) => t[r]
    );
  },
  getUrl() {
    return n(this.getTag, (t) => q(t, "url"));
  }
}), ei = {
  state: {},
  reducers: Xr,
  effects: Zr,
  selectors: Fr
}, ti = {
  boostRemaining: 0,
  chestsCount: 0,
  currentPoints: 0,
  excludedFromSR: !1,
  excludedUser: !1,
  goingToTierDown: !1,
  goingToTierUp: !1,
  hideChests: !1,
  nextBoostTimeHours: 0,
  nextBoostTimeMinutes: 0,
  optinNotificationActive: !1,
  showTierUp: !1,
  starCoinBalance: 0,
  targetPoints: 0,
  tierId: pt.Blue,
  tierUpEndHours: 0,
  tierUpEndMinutes: 0,
  userExcluded: !1,
  userOptedIn: !1
}, ni = {
  boostEnabled: !1,
  canExchange: !1,
  cvl2: !0,
  daysToExpire: 0,
  exchangePercent: 0,
  expiresOn: "",
  goingToTierDown: !1,
  goingToTierUp: !1,
  recentBarCounter: 0,
  showTierDownExchange: !1,
  showTierDownPopUp: !1,
  showTierUpPopUp: !1,
  startedOn: "",
  tierDownDays: 0,
  tierUpBars: 0,
  tierUpDays: 0,
  timezone: "",
  totalDoneBarCount: 0,
  chestHistory: []
}, Ot = {
  subscriptions: {},
  oldPoints: 0
}, ri = {
  set: (e, n) => ({ ...e, ...n }),
  "session/clear": () => Ot
}, ii = (e, n) => ({
  get() {
    return e((t) => t || {});
  },
  getCvlBarData() {
    return e((t) => t.data?.cvlBar || ti);
  },
  getCvlConfigData() {
    return e((t) => t.data?.cvlConfig || ni);
  },
  getRewardsBrand() {
    return n(
      (t) => a.cms.getBrandId(t),
      (t) => {
        switch (t) {
          case _.FoxBet:
            return ge.FoxBet;
          default:
            return ge.PokerStars;
        }
      }
    );
  }
}), si = {
  state: Ot,
  reducers: ri,
  selectors: ii
}, nt = 1e3, gt = ({ getState: e, select: n, dispatch: t }, r) => {
  const i = new URL(n.location.getOrigin(e()));
  return i.pathname = "/api/v0/websocket", fr({
    requestDestination: "/service/",
    requestTimeout: n.config.get(e()).requestTimeout ?? 2e4,
    responseChannel: "/user/queue/messages",
    url: R ? i.pathname : i.toString(),
    sockJSOptions: { transports: ["websocket"] },
    getHeaders: () => {
      const { token: s } = n.session.get(e());
      return s ? { authorization: `StarsWeb-Session ${s}` } : void 0;
    },
    getReconnect: (s, o) => (o === Ee.InvalidToken && t.session.clear(), s ? s === 1 ? nt : s * 2 : o === Ee.VelocityControl ? nt : 1),
    ...r
  });
}, oi = (e, {
  select: n,
  rootState: t,
  dispatch: r
}, i = {}, s) => {
  const c = gt({ getState: () => t, select: n, dispatch: r }, s);
  return It(e, i, c);
}, ai = ["cashier", "notifications", "crm"], ci = /* @__PURE__ */ new Map([
  [_.PokerStarsCasino, ["casino"]],
  [_.BetStars, ["sports"]]
]), ui = 60 * 1e3, di = {
  update: (e, { body: n }) => ({
    ...e,
    ...n,
    ...Nn ? JSON.parse(localStorage.getItem("status-check") || "{}") : {}
  })
}, Ce = {
  async check(e, n) {
    await Promise.all([
      Ce.checkCore(void 0, n),
      Ce.checkSports(void 0, n)
    ]);
  },
  async checkCore(e, { dispatch: n, request: t }) {
    try {
      n.system.update(
        await t({
          service: "/api/v1-preview/system/status",
          http: !0
        })
      );
    } catch {
    }
  },
  async checkSports(e, { select: n, dispatch: t, request: r, rootState: i }) {
    if (n.feature.check(i, g.ISPStatusCheck))
      try {
        const s = n.cms.getBrandId(i) === _.BetStars, o = n.system.getStatus(i, "sports"), c = await r({
          service: "/sports/web/status",
          http: !0
        });
        R && o === "red" && c.body.sports === "green" && s ? localStorage.getItem("sportsReloaded") || (localStorage.setItem("sportsReloaded", "1"), window.location.reload()) : (R && localStorage.removeItem("sportsReloaded"), t.system.update(c));
      } catch (s) {
        Ue.captureException(s), t.system.update({ body: { sports: "red" } });
      }
  },
  async subscribe(e, n) {
    oi("/topic/system/status", n).subscribe(
      n.dispatch.system.update
    ), a.feature.check(n.rootState, g.ISPStatusCheck) && setInterval(n.dispatch.system.checkSports, ui);
  }
}, li = (e, n) => ({
  get() {
    return e;
  },
  getStatus() {
    return n(
      e,
      (t, r) => r,
      (t, r) => q(t, r, "green")
    );
  },
  isAvailable() {
    return (t, r) => Ut([...ai, ...ci.get(a.cms.getBrandId(t)) || []]).every(
      (i) => this.getStatus(t, i) !== "red"
    );
  },
  isCMSAvailable() {
    return (t, r) => ![_.PokerStars, _.PokerStarsCasino, _.BetStars].includes(
      a.cms.getBrandId(t)
    ) || this.getStatus(t, "cms") !== "red";
  },
  isRAMAvailable() {
    return (t, r) => ["auth", "account"].every((i) => this.getStatus(t, i) !== "red");
  }
}), pi = {
  state: {},
  reducers: di,
  effects: Ce,
  selectors: li
}, mi = {
  account: St,
  device: Cr,
  resolver: ei,
  session: jn,
  currency: br,
  config: dr,
  country: mr,
  modal: zr,
  feature: Ur,
  system: pi,
  location: Yr,
  locale: xr,
  cms: or,
  localSettings: Vr,
  rewards: si
}, Ei = (e) => (n) => {
  const t = gt(e), { select: r, getState: i, dispatch: s } = e, o = i(), c = r.device.isEmbedded(o), d = r.device.getId(o), l = r.device.getOS(o), { token: m } = r.session.get(o), p = r.currency.get(o), E = r.locale.get(o), { href: N, origin: D, host: C } = r.location.get(o), v = r.device.getPlatform(o), A = { referer: N, "x-fi-ps-platform-id": `${v}` }, S = n.service.startsWith("/sports");
  if (m && (A.authorization = `StarsWeb-Session ${m}`), n.http ? (A["x-stars-currency"] = p, A["x-stars-locale"] = E) : Object.assign(A, { currency: p, locale: E }), R || (n.httpDomain = D, A.origin = D), !R && n.http)
    A["x-stars-embedded"] = c ? "1" : "0", A["x-device"] = `${d}`, A["x-os-family"] = `${l}`, A["x-stars-currency"] = p, A["x-stars-locale"] = E, A["x-forwarded-host"] = C;
  else if (!R) {
    const I = A;
    I.device = `${d}`, I.os = `${l}`, I.locale = E, I.embedded = c ? "1" : "0", I["x-forwarded-host"] = C;
  }
  try {
    return Or(_e({ headers: A, connection: t }, n));
  } catch (I) {
    const b = I;
    if (S && b.body.code === "MAINTENANCE" && s.system.update({ body: { sports: "red" } }), S && b.statusCode === 401) {
      const B = () => s.modal.enqueue({ path: "/sports/logged-out" });
      c ? document.addEventListener("starslogout", B, { once: !0 }) : (s.auth.logout(), B());
    }
    throw I;
  }
}, _i = () => {
  const e = new Kt(), n = {};
  return {
    config: {
      redux: {
        middlewares: [
          (t) => (r) => (i) => {
            const s = r(i);
            return e.next({ ...i, state: t.getState() }), s;
          }
        ]
      }
    },
    onModel(t, r) {
      const { name: i, effects: s } = t, { dispatch: o } = r, c = Ei(r);
      if (s) {
        if (typeof s == "function")
          throw new Error(
            "Model effects must be plain objects, global dispatch is provided to each effect."
          );
        Object.entries(s).forEach(([d, l]) => {
          n[`${i}/${d}`] = (m, p) => l(m, { actions: e, dispatch: o, rootState: p, select: r.select, request: c });
        });
      }
    },
    onStoreCreated(t, r) {
      r.effects = n;
    }
  };
}, fi = [
  u.COM,
  u.DE,
  u.DESH,
  u.DK,
  u.ES,
  u.EU,
  u.GR,
  u.NL,
  u.PT,
  u.RO,
  u.SE,
  u.UK,
  u.USCO,
  u.USMI,
  u.USNJ,
  u.USPA,
  u.CAON
], hi = [Rn(), _i()], Si = (e) => {
  const t = { models: Object.assign({}, mi, e.models), plugins: hi };
  return yt(_e(e, t));
}, { select: a } = Si({ name: "core-store" }), Ii = kt, Ai = ({
  vegas: e,
  showVegasContent: n,
  ontario: t,
  showOntarioContent: r
}) => e && n ? { defaultMessage: e } : t && r ? { defaultMessage: t } : {}, Ri = ({ vegas: e, ontario: n }) => {
  const t = M(a.cms.showVegasContent), r = M(a.cms.showOntarioContent);
  return Te(
    () => Ai({ vegas: e, ontario: n, showVegasContent: t, showOntarioContent: r }),
    [t, e, r, n]
  );
};
const Oi = "_32b5e3e", gi = {
  starsLink: Oi
}, Ni = (e) => /* @__PURE__ */ y.createElement("a", { ...e, className: nn(gi.starsLink, e.className) }, e.children), Pi = "PokerStars Casino", Di = "PokerStars Vegas", wi = ({ resolve: e, domain: n, values: t } = {}) => {
  const r = M(a.cms.getDomain), i = M(a.cms.getBrandId), s = M(a.cms.getBrandName), o = M(a.cms.getStarsDomain), c = M(a.cms.showVegasContent), d = M(a.rewards.getRewardsBrand);
  return Te(() => {
    const m = {
      appDomain: r,
      appStarsdomain: o,
      accountBrand: i === _.FoxBet ? "User" : "Stars",
      brandCoin: "StarsCoin",
      brand: c && [_.PokerStarsCasino, _.PokerStarsVegas].includes(i) ? Di : i === _.PokerStarsCasino ? Pi : s,
      rewardsBrand: d,
      ...t
    };
    return e && Object.entries(e).forEach(([p, E]) => {
      const { emailLink: N, emailText: D } = Ln(
        p,
        E,
        n,
        o,
        Ni
      );
      D && (m[p] = D), N && (m[p] = N);
    }), m;
  }, [
    r,
    i,
    s,
    n,
    t,
    e,
    o,
    c,
    d
  ]);
}, bi = () => {
  const e = ne(!1), n = J(() => e.current, []);
  return X(() => (e.current = !0, () => {
    e.current = !1;
  }), []), n;
}, rt = (e) => {
  const n = ne(e);
  return X(() => {
    n.current = e;
  }), n.current;
}, os = (e, n) => {
  const t = ne(!1);
  return X(() => {
    if (n)
      return e && !t.current ? (Qe(n), t.current = !0) : !e && t.current && (he(n), t.current = !1), () => {
        n && t.current && (he(n), t.current = !1);
      };
  }, [e, n, t]), { lock: Qe, unlock: he };
}, as = (e = R ? window.opener || window.parent : null) => {
  const n = M(a.location.getCookieDomain);
  return J(
    (t) => {
      const r = new W(document.referrer);
      r.hostname.endsWith(n) && e.postMessage(t, r.origin);
    },
    [n, e]
  );
}, cs = ({ children: e, isOpen: n, createPortal: t = !0, onClose: r, ...i }) => {
  const s = ne(null), o = M(a.device.isMobile), c = J(
    () => /* @__PURE__ */ U(sn, { ...i, innerRef: s, children: e }),
    [e, i]
  ), d = J(
    (l) => {
      if (!n)
        return;
      const m = s.current;
      r && m && !m.contains(l.target) && r();
    },
    [n, r]
  );
  return X(() => (R && r && (o ? window.addEventListener("touchend", d, !1) : window.addEventListener("click", d, !1)), () => {
    R && r && (o ? window.removeEventListener("touchend", d, !1) : window.removeEventListener("click", d, !1));
  }), [d, o, r]), n ? t ? R ? rn.createPortal(c(), document.getElementById("root")) : null : c() : null;
};
class us extends y.PureComponent {
  constructor() {
    super(...arguments), this.toggle = (n) => {
      n.stopPropagation(), n.preventDefault(), this.props.onToggle?.();
    };
  }
  // TODO: refactor with `usePopper`
  render() {
    return /* @__PURE__ */ U(on, { children: ({ ref: n }) => y.cloneElement(y.Children.only(this.props.children), {
      onClick: this.toggle,
      onMouseOver: this.props.onMouseOver,
      onMouseLeave: this.props.onMouseLeave,
      ref: n
    }) });
  }
}
const Nt = y.createContext(null), Li = ({
  history: e,
  children: n
}) => /* @__PURE__ */ y.createElement(Nt.Provider, { value: e }, n);
Ht(
  (e) => /* @__PURE__ */ y.createElement(Li, { ...e })
);
const ds = () => {
  const e = wt(Nt);
  return J(
    (n) => e?.push(n),
    [e]
  );
}, ls = (e, n = {}) => {
  const t = M(a.cms.getBrandName), r = M(a.cms.getSiteName), { resolver: i } = Ii(), [s, o] = bt(""), c = rt(e), d = rt(t), l = bi(), { getState: m } = Gt(), p = J(
    async (E, N) => {
      await i.fetchTag({ tag: E, ...N });
      const D = a.resolver.getTag(m(), E);
      D && l() && o(D?.url);
    },
    [m, l, i]
  );
  return X(() => {
    e && (!s || e !== c || t !== d) && p(e, n);
  }, [p, e, s, r, t, c, n, d]), s;
}, ps = () => {
  const e = ne(!1), { pauseValidation: n, resumeValidation: t } = an();
  e.current || (n(), e.current = !0), X(() => t(), [t]);
};
export {
  cs as Tooltip,
  us as TooltipReference,
  ss as Translation,
  Ai as getOverrideTranslation,
  os as useBodyScrollLock,
  bi as useIsMounted,
  ds as useNavigate,
  ps as usePauseValidator,
  as as usePostMessage,
  rt as usePrevious,
  Ri as useRegulatoryOverride,
  ls as useResolver,
  wi as useTranslationValues
};
